/* globals authorize, strip, findInArray, appendQueryParam */
(function () {

	angular.module('app.core')
		.service('leanFilterService', leanFilterService);

	leanFilterService.$inject = ['$rootScope', '$http', '$timeout', '$filter', '$translate', '$location', '$q', '$experiments', 'URLS', 'filterDefinitionsService', 'storeService'];
	function leanFilterService($rootScope, $http, $timeout, $filter, $translate, $location, $q, $experiments, URLS, filterDefinitionsService, storeService) {
		var self = this;
		window.leanFilterService = self;
		self.masterFilterList = [];
		self.masterRangeFilterList = [];
		self.masterDateFilterList = [];
		self.masterStringFilterList = [];
		self.masterSingleSelectFilterList = [];
		self.activeFilters = [];
		self.searchBoxData = '';
		self.defaultFilters = [];
		self.updatingFilters = true;
		self.myItemFilter = {
			'enabled': false,
			'selected': false
		};

		var firstFilterLoad = false;
		var checkedBackendValues = false;
		var savedQueryParam = undefined;
		var factoryFilterChanged = false;
		var timeoutForPopoverOpen = undefined;
		var timeoutForPopoverLeave = undefined;
		self.isFirstLoadDrilldown = false;
		self.factoriesSelected = false;
		self.leanDnaAllSelected = 'LDNA_A_S';
		self.useFactoryFilter = false;
		self.useAdminFactory = false;
		self.spendSummaryReportGroup = null;
		var currentAsync = 0, lastAsync = 0;
		self.filtersHaveBeenUpdatedFromConfig = false;
		self.searchType = 'item';
		self.cancel = $q.defer();
		self.comparators = [
			{ 'name': 'Less Than', 'abbr': 'lt' },
			{ 'name': 'Less Than Or Equal To', 'abbr': 'lte' },
			{ 'name': 'Equal To', 'abbr': 'eq' },
			{ 'name': 'Not Equal To', 'abbr': 'noteq' },
			{ 'name': 'Greater Than', 'abbr': 'gt' },
			{ 'name': 'Greater Than or Equal To', 'abbr': 'gte' },
			{ 'name': 'Between', 'abbr': 'btw' },
			{ 'name': 'Not Between', 'abbr': 'notbtw' }];
		self.comparatorsMap = {
			lessThan: 'Less Than',
			lessThanOrEqual: 'Less Than Or Equal To',
			equal: 'Equal To',
			notEqual: 'Not Equal To',
			greaterThan: 'Greater Than',
			greaterThanOrEqual: 'Greater Than or Equal To',
			between: 'Between',
			notBetween: 'Not Between',
			nextWeek: 'nextWeek',
			next30Days: 'next30Days',
			next60Days: 'next60Days',
			next90Days: 'next90Days',
			ctbWindow: 'ctbWindow',
			ctcWindow: 'ctcWindow',
			custom: 'custom'
		};

		self.filterDefinitions = filterDefinitionsService.getFilterDefinitions();
		self.showResetReportSettings = false;
		self.isGlobalReportSettings = false;
		self.reportSettingsScope = null;
		self.reportSettingsName = null;
		self.reportName = undefined;
		self.reportSettingsId = undefined;
		self.getFlexFiltersByTypeAndReport = getFlexFiltersByTypeAndSource;
		self.addFlexFiltersBySourceType = addFlexFiltersBySourceType;
		self.setAllFilterLists = setAllFilterLists;
		self.clearFilters = clearFilters;
		self.setMasterFilterList = setMasterFilterList;
		self.setMasterRangeFilterList = setMasterRangeFilterList;
		self.setMasterStringFilterList = setMasterStringFilterList;
		self.setMasterSingleSelectFilterList = setMasterSingleSelectFilterList;
		self.getTypeOfFilter = getTypeOfFilter;
		self.isCustomFilter = isCustomFilter;
		self.getSelectedIds = getSelectedIds;
		self.getSelectedLabels = getSelectedLabels;
		self.getUnselectedIds = getUnselectedIds;
		self.getSelectedAlternateKeys = getSelectedAlternateKeys;
		self.getUnselectedAlternateKeys = getUnselectedAlternateKeys;
		self.getNewQueryParam = getNewQueryParam;
		self.getSearchData = getSearchData;
		self.loadFilters = loadFilters;
		self.reloadFactoryFilters = reloadFactoryFilters;
		self.getFilterById = getFilterById;
		self.getFilterByDefinitionName = getFilterByDefinitionName;
		self.getList = getList;
		self.getComparator = getComparator;
		self.getValueOne = getValueOne;
		self.getValueTwo = getValueTwo;
		self.getValue = getValue;
		self.setComparator = setComparator;
		self.setValueOne = setValueOne;
		self.setValueTwo = setValueTwo;
		self.setValue = setValue;
		self.getUrl = getUrl;
		self.getComparisonKey = getComparisonKey;
		self.getAuthorizationLevel = getAuthorizationLevel;
		self.getAlternateKey = getAlternateKey;
		self.getLabel = getLabel;
		self.getDisplayName = getDisplayName;
		self.setSearchBoxDataValue = setSearchBoxDataValue;
		self.getSearchBoxDataValue = getSearchBoxDataValue;
		self.isLoading = isLoading;
		self.clearFiltersLoaded = clearFiltersLoaded;
		self.getDisplayForRange = getDisplayForRange;
		self.getDisplayForString = getDisplayForString;
		self.selectAllInActiveFilters = selectAllInActiveFilters;
		self.updateActiveFilters = updateActiveFilters;
		self.updateActiveFiltersRedux = updateActiveFiltersRedux;
		self.getFilterConfigForStorage = getFilterConfigForStorage;
		self.getFiltersForPost = getFiltersForPost;
		self.updateFactoryFilterFromStoredConfig = updateFactoryFilterFromStoredConfig;
		self.updateFiltersFromStoredConfig = updateFiltersFromStoredConfig;
		self.getFactoryList = getFactoryList;
		self.getQueryParam = getQueryParam;
		self.getDefaultFilters = getDefaultFilters;
		self.addFilterQueryParams = addFilterQueryParams;
		self.getQueryParamsObject = getQueryParamsObject;
		self.getTimePeriodFilterQueryParam = getTimePeriodFilterQueryParam;
		self.updateHierarchicalFilters = updateHierarchicalFilters;
		self.deleteReportSettings = deleteReportSettings;
		self.getUserAssignedBuyerCodes = getUserAssignedBuyerCodes;
		self.shouldEnableMyItemsOnlyFilter = shouldEnableMyItemsOnlyFilter;
		self.setResetReportSettingsSettings = setResetReportSettingsSettings;
		self.updateFiltersDependsOnMyItemFilter = updateFiltersDependsOnMyItemFilter;
		self.getDataSyncIssueTooltip = getDataSyncIssueTooltip;
		self.popoverForDataSyncOpened = false;
		self.mouseOverDataSync = mouseOverDataSync;
		self.mouseLeaveDataSync = mouseLeaveDataSync;
		self.handlePopoverClick = handlePopoverClick;
		self.escapeCommasForOrderPolicies = escapeCommasForOrderPolicies;
		self.getGroupKey = getGroupKey;
		self.getGroupLabels = getGroupLabels;
		self.addCustomFieldsFilters = addCustomFieldsFilters;
		self.getCustomFieldFilterNames = getCustomFieldFilterNames;

		function getDefaultSiteForSiteFilter(sitesList) {
			var defaultSite = globalConfig.factory.id.toString();
			if (sitesList && sitesList.length) {
				var isCurrentSiteExists = _.some(sitesList, function(data) {
					return data.id === globalConfig.factory.id;
				});
				if (!isCurrentSiteExists) {
					defaultSite = sitesList[0].id.toString();
				}
			}
			return defaultSite;
		}

		function getFlexFiltersByTypeAndSource(filterType, sourceType) {
			return _.filter(self.filterDefinitions, function (filter) {
				return filter.type && filter.type.toLowerCase() === filterType.toLowerCase() && filter.sourceType && filter.sourceType.toLowerCase() === sourceType.toLowerCase();
			});
		}

		function addFlexFiltersBySourceType(sourceTypes, filters) {
			filters.multiSelectFilters = filters.multiSelectFilters || [];
			filters.rangeFilters = filters.rangeFilters || [];
			filters.stringFilters = filters.stringFilters || [];
			_.each(sourceTypes, function (sourceType) {
				filters.multiSelectFilters.push.apply(filters.multiSelectFilters, getFlexFiltersByTypeAndSource('multiselect', sourceType));
				filters.rangeFilters.push.apply(filters.rangeFilters, getFlexFiltersByTypeAndSource('date', sourceType));
				filters.rangeFilters.push.apply(filters.rangeFilters, getFlexFiltersByTypeAndSource('numerical', sourceType));
				filters.stringFilters.push.apply(filters.stringFilters, getFlexFiltersByTypeAndSource('string', sourceType));
			});
			return filters;
		}

		function setAllFilterLists(filters) {
			filters.multiSelectFilters && setMasterFilterList(filters.multiSelectFilters);
			filters.rangeFilters && setMasterRangeFilterList(filters.rangeFilters);
			filters.singleSelectFilters && setMasterSingleSelectFilterList(filters.singleSelectFilters);
			filters.stringFilters && setMasterStringFilterList(filters.stringFilters);
		}

		function clearFilters() {
			self.showResetReportSettings = false;
			self.isGlobalReportSettings = false;
			self.reportSettingsScope = null;
			self.reportSettingsName = null;
			self.factoriesSelected = false;
			self.useFactoryFilter = false;
			self.useAdminFactory = false;
			self.updatingFilters = true;
			self.isFirstLoadDrilldown = getQueryParamFromPath().drilldown === '1';
			self.setMasterRangeFilterList([]);
			self.setMasterStringFilterList([]);
			self.setMasterFilterList([]);
			self.setMasterSingleSelectFilterList([]);
			filterDefinitionsService.clearSelectedAndUnselected();
			self.filterDefinitions = filterDefinitionsService.getFilterDefinitions();
			self.filtersHaveBeenUpdatedFromConfig = false;
			self.activeFilters.length = 0;
			currentAsync = 0;
			checkedBackendValues = false;
			savedQueryParam = undefined;
			factoryFilterChanged = false;
			self.reportSettingsId = undefined;
			self.reportName = undefined;
			self.myItemFilter = {
				'enabled': false,
				'selected': false,
				'value': self.getUserAssignedBuyerCodes().join(',')
			};
		}

		function getUserAssignedBuyerCodes() {
			var buyerCodes = new Set();
			angular.forEach(globalConfig.user.authFacts, function (factory) {
				if (globalConfig.customer.id === factory.customerNdx) {
					if (factory.userAssignedBuyerCodes) {
						angular.forEach(factory.userAssignedBuyerCodes, function (buyerCode) {
							buyerCodes.add(buyerCode.toUpperCase());
						});
					}
				}
			});
			return Array.from(buyerCodes);
		}

		function shouldEnableMyItemsOnlyFilter(existingBuyerCodesPerFactory, assignedBuyerCodes) {
			for (var i = 0; i < existingBuyerCodesPerFactory.length; i++) {
				if (assignedBuyerCodes.includes(existingBuyerCodesPerFactory[i].buyerCode.toUpperCase())) {
					return true;
				}
			}
			return false;
		}

		function setResetReportSettingsSettings(reportSettingsName, reportSettingsScope) {
			self.showResetReportSettings = $location.search().showReset;
			self.reportSettingsName = reportSettingsName;
			self.reportSettingsScope = reportSettingsScope;
		}

		function checkIfFilterAllowedByRole(filter) {
			if(globalConfig.user.role === 'Supplier') {
				// assign to avoid immutability error
				var supplierAllowedColumns = _.uniq(globalConfig.user.allowedColumns.default.concat(globalConfig.user.allowedColumns.allowed || []));
				switch(filter.id) {
				case 'factory': {
					return true;
				}
				case 'shortageCriticalityLevelId': {
					return supplierAllowedColumns.includes('shortageCriticalityLevelLabel');
				}
				case 'poStatusCategoryNdx': {
					return supplierAllowedColumns.includes('poStatusCategoryDescription');
				}
				case 'bucketType': {
					return supplierAllowedColumns.includes('LOB');
				}
				case 'isBlanketOrder': {
					return supplierAllowedColumns.includes('isBlanketOrder');
				}
				default: {
					return supplierAllowedColumns.includes(filter.id);
				}
				}
			}

			return true;
		}

		function setMasterFilterList(filterList) {
			self.masterFilterList.length = 0;
			angular.forEach(filterList, function (filter) {
				var addFilter = false;
				if (typeof filter.authz !== 'undefined' && authorize(filter.authz)) {
					addFilter = true;
				}

				if (addFilter) {
					addFilter = checkIfFilterAllowedByRole(filter);
				}

				if (addFilter) {
					self.masterFilterList.push(filter);
				}
			});
		}

		function setMasterRangeFilterList(filterList) {
			self.masterRangeFilterList.length = 0;
			angular.forEach(filterList, function (filter) {
				var addFilter = false;
				if (typeof filter.authz !== 'undefined' && authorize(filter.authz)) {
					addFilter = true;
				}

				if (addFilter) {
					addFilter = checkIfFilterAllowedByRole(filter);
				}

				if (addFilter) {
					self.masterRangeFilterList.push(filter);
				}
			});
		}

		function setMasterStringFilterList(filterList) {
			self.masterStringFilterList.length = 0;
			angular.forEach(filterList, function (filter) {
				var addFilter = false;
				if (typeof filter.authz !== 'undefined' && authorize(filter.authz)) {
					addFilter = true;
				}

				if (addFilter) {
					addFilter = checkIfFilterAllowedByRole(filter);
				}

				if (addFilter) {
					self.masterStringFilterList.push(filter);
				}
			});
		}

		function setMasterSingleSelectFilterList(filterList) {
			self.masterSingleSelectFilterList.length = 0;
			angular.forEach(filterList, function (filter) {
				var addFilter = false;
				if (typeof filter.authz !== 'undefined' && authorize(filter.authz)) {
					addFilter = true;
				}

				if (addFilter) {
					addFilter = checkIfFilterAllowedByRole(filter);
				}

				if (addFilter) {
					self.masterSingleSelectFilterList.push(filter);
				}
			});
		}

		function getTypeOfFilter(filterId) {
			var filter = getFilterById(filterId);
			if (filter) {
				return filter.type;
			}
			return '';
		}

		function isCustomFilter(filterId) {
			var filter = getFilterById(filterId);
			if (filter) {
				return filter.isCustom;
			}
			return false;
		}

		function getNewQueryParam(id, useCode) {
			var selected = getSelectedIds(id);
			var filter = getFilterById(id);
			var objList = filter.objectList;
			if (selected.length < (objList.length / 2)) {
				if (useCode) {
					return '&supplierCode=' + self.getSelectedAlternateKeys(id);
				} else {
					return '&' + id + '=' + self.getSelectedIds(id);
				}
			} else {
				if (useCode) {
					return '&notSupplierCode=' + self.getUnselectedAlternateKeys(id);
				} else {
					var temp = id.charAt(0).toUpperCase() + id.slice(1);
					return '&not' + temp + '=' + self.getUnselectedIds(id);
				}
			}
		}

		function _getFilterData(filterId, forceUseList) {
			var filter = getFilterById(filterId);
			var readyToLoad = true;
			if (!filter) {
				return;
			}
			if (filter.url) {
				if (filter.updateOnFactory && self.useFactoryFilter) {
					readyToLoad = false;
					if (self.factoriesSelected) {
						var selectedFactories = self.getFactoryList(undefined, forceUseList);
						if (_.isString(selectedFactories)) {
							selectedFactories = selectedFactories.split(',');
						}
						if (selectedFactories[0] === self.leanDnaAllSelected) {
							selectedFactories = '';
							var factoryFilter = getFilterById('factory');
							var factoryFilterObjList = factoryFilter.objectList;
							for (var i = 0; i < factoryFilterObjList.length; i++) {
								if (i > 0) {
									selectedFactories += ',';
								}
								selectedFactories += factoryFilterObjList[i][factoryFilter.comparisonKey];
							}
						}
						readyToLoad = true;
						if (!selectedFactories || !selectedFactories.length) {
							selectedFactories = globalConfig.factory.id;
						}
						var urlIndex = selectedFactories;
						if (filter.unformattedUrl.includes('/companyId/')) {
							urlIndex = globalConfig.customer.id;
						}
						var hasQueryParam = filter.unformattedUrl.indexOf('?') >= 0;
						filter.url = String.format(filter.unformattedUrl, urlIndex) + _getHierarchyQueryParam(hasQueryParam);
					} else {
						$timeout(function () {
							_getFilterData(filterId);
						}, 10);
					}
				} else {
					if (typeof filter.unformattedUrl !== 'undefined' && !self.useFactoryFilter) {
						filter.url = String.format(filter.unformattedUrl, self.useAdminFactory ? 
							storeService.getState().adminConfig.factory.id : globalConfig.factory.id);
					}
				}
				if (readyToLoad) {
					if (filter.id === 'factory') {
						currentAsync--;
						return;
					}
					var request = {
						method: 'GET',
						url: URLS.host + filter.url,
						timeout: self.cancel.promise
					};
					if (filter.extraParams && filter.extraParamReportNames && filter.extraParamReportNames.includes(globalReportName)) {
						request.params = filter.extraParams;
					}
					$http(request)
						.then(function (response) {
							filter.objectList.length = 0;
							var excludedOptions = [];
							if (filter.staticOption) {
								for (var i = 0; i < filter.staticOption.length; i++) {
									filter.objectList.push(filter.staticOption[i]);
									if (filter.staticOption[i].excludeMatchingOption === true) {
										excludedOptions.push(filter.staticOption[i][filter.comparisonKey]);
									}
								}
							}
							if (filter.excludeOptionNames && filter.excludeOptionNames.length) {
								excludedOptions = excludedOptions.concat(filter.excludeOptionNames);
							}

							angular.forEach(response.data, function (item) {
								if (filter.formatType && filter.format) {
									item.formatType = filter.formatType;
									item.format = filter.format;
								}
								if (filter.strip) {
									item[filter.label] = _.unescape(strip(item[filter.label]));
								}
								if (typeof filter.optionMap === 'function') {
									item = filter.optionMap(item);
								}
								if (filter.id === 'taskStatus') {
									item.name = item.name === 'Review Later' ? 'In Progress' : item.name;
								}
								if (excludedOptions.indexOf(item[filter.comparisonKey]) === -1) {
									filter.objectList.push(item);
								}
							});

							if (filter.checkMyItems) {
								if (self.myItemFilter.value) {
									self.myItemFilter.enabled = self.shouldEnableMyItemsOnlyFilter(filter.objectList, self.myItemFilter.value.split(','));
								}
							}
							currentAsync--;
						});
				}
			} else if (filter.loadObjectList) {
				if (filter.updateOnFactory && self.useFactoryFilter) {
					if (self.factoriesSelected) {
						var selectedFactories = self.getFactoryList(undefined, forceUseList);
						var factoryids = [];
						if (selectedFactories[0] === self.leanDnaAllSelected) {
							var factoryFilter = getFilterById('factory');
							var factoryFilterObjList = factoryFilter.objectList;
							for (var i = 0; i < factoryFilterObjList.length; i++) {
								selectedFactories.push[factoryFilterObjList[i][factoryFilter.comparisonKey]];
							}
						}
						if (!selectedFactories || !selectedFactories.length) {
							factoryids.push(globalConfig.factory.id);
						} else {
							factoryids = _.map(selectedFactories.split(','), Number);
						}

						filter.loadObjectList(factoryids, filter);
					} else {
						$timeout(function () {
							_getFilterData(filterId);
						}, 10);
					}
				}
			}
		}

		function getSelectedLabels(filterId, alternateKey) {
			var list = [];
			var allSelected = true;
			angular.forEach(self.getList(filterId), function (item) {
				if (item.selected) {
					var val = item[alternateKey || self.getLabel(filterId)];
					var filt = getFilterById(filterId);
					if (filt.undefinedMap) {
						val = JSON.parse(filt.undefinedMap)[val] || val;
					}
					if (item.format && item.formatType) {
						val = $filter(item.formatType)(val, item.format);
					}
					list.push($translate.instant(val));
				} else {
					allSelected = false;
				}
			});
			if (getFilterById(filterId).type === 'singleSelect') {
				return list;
			}
			return allSelected ? ['All'] : list;
		}

		function getSelectedIds(filterId, notDefaultAll) {
			var filter = getFilterById(filterId);
			if (!filter) {
				return [];
			}
			if (!firstFilterLoad) {
				return _.clone(filter.selectedList);
			}
			var list = [];
			var allSelected = !notDefaultAll;
			angular.forEach(filter.objectList, function (item) {
				if (item.selected) {
					list.push(item[filter.comparisonKey]);
				} else {
					allSelected = false;
				}
			});
			if (filter.type === 'singleSelect') {
				return list;
			}

			if (filter.type === 'multiselect' && filter.objectList.length === 0) {
				return list;
			}
			return allSelected && !filter.sendAllValues ? [self.leanDnaAllSelected] : list;
		}

		function getUnselectedIds(filterId) {
			if (!firstFilterLoad) {
				var filter = getFilterById(filterId);
				return _.clone(filter.unselectedList);
			}
			var list = [];
			var allSelected = true;
			angular.forEach(self.getList(filterId), function (item) {
				if (!item.selected) {
					allSelected = false;
					list.push(item[self.getComparisonKey(filterId)]);
				}
			});
			return allSelected ? [self.leanDnaAllSelected] : list;
		}

		function getSelectedAlternateKeys(filterId) {
			var list = [];
			var allSelected = true;
			angular.forEach(self.getList(filterId), function (item) {
				if (item.selected) {
					list.push(item[self.getAlternateKey(filterId)]);
				} else {
					allSelected = false;
				}
			});
			return allSelected ? [self.leanDnaAllSelected] : list;
		}

		function getUnselectedAlternateKeys(filterId) {
			var list = [];
			var allSelected = true;
			angular.forEach(self.getList(filterId), function (item) {
				if (!item.selected) {
					list.push(item[self.getAlternateKey(filterId)]);
					allSelected = false;
				}
			});
			return allSelected ? [self.leanDnaAllSelected] : list;
		}

		function getSearchData(searchValue) {
			var requestUrl;
			switch (self.searchType) {
			case 'supplier':
				requestUrl = String.format(URLS.supplierSearch, self.getFactoryList(), encodeURIComponent(searchValue));
				return $http.get(URLS.host + requestUrl);
			case 'user':
				requestUrl = String.format(URLS.userSearch, encodeURIComponent(searchValue));
				return $http.get(URLS.host + requestUrl);
			case 'item':
				requestUrl = String.format(URLS.searchItemCodes, self.getFactoryList());
				var body = {
					operation: 'rows',
					columns: [],
					filters: [],
					paging: {
						start: 0,
						limit: 10
					},
					extraParams: {
						search: searchValue,
						typeahead: true
					}
				};
				return $http.post(URLS.host + requestUrl, body, { ignoreLoadingBar: true });
			default:
				return false;
			}
		}

		// donotCallUpdateFilters: Prevents the calling to updateActiveFilters again as merge config is already calling the
		// updateActiveFilters method. There is a timout with in the updateActiveFilters that call the function again if conditions are not
		// satisfied. Due to multiple call to updateActiveFilters, causes a condition where filters are no fully populated and
		// one of the timeout function call gets finished to recall the method.
		function loadFilters(donotCallUpdateFilters) {
			firstFilterLoad = true;
			_loadListData(null, donotCallUpdateFilters);
		}

		function updateHierarchicalFilters(usingReduxStore) {
			var selectedBusinessUnits = getSelectedIds('businessunit') || [];
			var divisionFilter = getFilterById('division');
			if (divisionFilter) {
				var selectedDivisionsFromObjectList = divisionFilter.objectList.reduce(function(accumulator, division) {
					if (division.selected) {
						accumulator.push(division.division);
					}
					return accumulator;
				}, []);
				divisionFilter.objectList = divisionFilter.masterObjectList.filter(function(d) {
					if (getSelectedIds('division').length
						&& selectedDivisionsFromObjectList.length && selectedDivisionsFromObjectList.indexOf(d.division) !== -1) {
						d.selected = true;
					} else {
						d.selected = false;
					}
					return selectedBusinessUnits.length === 0 
						|| (selectedBusinessUnits.length === 1 && selectedBusinessUnits[0] === self.leanDnaAllSelected)
						|| _.intersection(d.businessunit, selectedBusinessUnits).length > 0;
				});
			}
			var selectedDivisions = getSelectedIds('division') || [];
			var entityFilter = getFilterById('entity');
			if (entityFilter) {
				var selectedEntitiesFromObjectList = entityFilter.objectList.reduce(function(accumulator, entity) {
					if (entity.selected) {
						accumulator.push(entity.entity);
					}
					return accumulator;
				}, []);
				entityFilter.objectList = entityFilter.masterObjectList.filter(function(e) {
					if (getSelectedIds('entity').length
						&& selectedEntitiesFromObjectList.length && selectedEntitiesFromObjectList.indexOf(e.entity) !== -1) {
						e.selected = true;
					} else {
						e.selected = false;
					}
					return (selectedBusinessUnits.length === 0
						|| (selectedBusinessUnits.length === 1 && selectedBusinessUnits[0] === self.leanDnaAllSelected)
						|| _.intersection(e.businessunit, selectedBusinessUnits).length > 0)
						&& (selectedDivisions.length === 0
							|| (selectedDivisions.length === 1 && selectedDivisions[0] === self.leanDnaAllSelected)
							|| _.intersection(e.division, selectedDivisions).length > 0);
				});
			}
			var selectedEntities = getSelectedIds('entity') || [];
			var factoryFilter = getFilterById('factory');
			var updateFactoryFilterInStore = false;
			if (factoryFilter) {
				var selectedFactoriesFromObjectList = factoryFilter.objectList.reduce(function(accumulator, factory) {
					if (factory.selected) {
						accumulator.push(factory.id);
					}
					return accumulator;
				}, []);
				factoryFilter.objectList = factoryFilter.masterObjectList.filter(function(f) {
					if (getSelectedIds('factory').length
						&& (selectedFactoriesFromObjectList.length && selectedFactoriesFromObjectList.indexOf(f.id) !== -1)) {
						f.selected = true;
					} else {
						f.selected = false;
					}
					return (
						selectedBusinessUnits.length === 0 ||
						_.intersection([f.businessunit], selectedBusinessUnits).length > 0 ||
						(selectedBusinessUnits.length === 1 && selectedBusinessUnits[0] === self.leanDnaAllSelected)
					) && (
						selectedDivisions.length === 0 ||
						(selectedDivisions.length === 1 && selectedDivisions[0] === self.leanDnaAllSelected) ||
						_.intersection([f.division], selectedDivisions).length > 0
					) && (
						selectedEntities.length === 0 ||
						(selectedEntities.length === 1 && selectedEntities[0] === self.leanDnaAllSelected) ||
						_.intersection([f.entity], selectedEntities).length > 0
					)
							&& (
								!factoryFilter.sboType 
									|| globalConfig.user.authFacts[f.id].settings.ShortageByOrderReport === factoryFilter.sboType
									|| (globalConfig.user.authFacts[f.id].settings.ShortageByOrderReport !== 'None' && factoryFilter.sboType === 'Custom Tabular Report (New)')
							);
				});

				if (!factoryFilter.removable && getSelectedIds('factory').length === 0) {
					// There is also a case if the selected factory for a user is removed from the user.
					// Mean user is removed from a factory but there is factory selection for that factory in the filter.
					// For single select filter we cannot set the value to all. So we will default the value to logged in site
					var defaultSelectedSite = getDefaultSiteForSiteFilter(factoryFilter.objectList);
					if (factoryFilter.type === 'singleSelect') {
						factoryFilter.selectedList = [defaultSelectedSite];
					}
					factoryFilter.objectList.map(function (filter) {
						if (factoryFilter.type === 'singleSelect') {
							if (filter.id.toString() === defaultSelectedSite) {
								filter.selected = true;
								updateFactoryFilterInStore = true;
							}
						} else {
							filter.selected = true;
						}
					});
				}
			}

			if (usingReduxStore) {
				var doNotSave = true;
				var userModified = storeService.getState().reportSettings.userModified;
				if (divisionFilter) {
					$timeout(function() {
						storeService.updateFilterSettings(divisionFilter, self.reportName, self.reportSettingsId, doNotSave, userModified);
					});
				}
				if (entityFilter) {
					$timeout(function() {
						storeService.updateFilterSettings(entityFilter, self.reportName, self.reportSettingsId, doNotSave, userModified);
					});
				}
				if (factoryFilter) {
					var factoryFilterSettings;
					var filterSettings = storeService.getState().reportSettings.filters;
					for(var i = 0; i < filterSettings.length; i++) {
						if(filterSettings[i].id === 'factory') {
							factoryFilterSettings = filterSettings[i];
						}
					}
					if(factoryFilterSettings || getSelectedIds('factory').length < factoryFilter.objectList.length || updateFactoryFilterInStore) {
						// Don't want to add factory=['LDNA_A_S'] if there's no factory filter present already
						$timeout(function() {
							factoryFilterChanged = true;
							storeService.updateFilterSettings(factoryFilter, self.reportName, self.reportSettingsId, doNotSave, userModified);
						});
					}
				}
			}
		}

		function storeLastFilterSelection(tempLists, filter, notDefaultAll) {
			tempLists[filter.id] = getSelectedIds(filter.id, notDefaultAll);
			if (filter.alternateComparisonKey) {
				if (_.isArray(filter.alternateComparisonKey)) {
					angular.forEach (filter.alternateComparisonKey, function(alternate) {
						tempLists[filter.id + '_' + alternate + '_alternate'] = getSelectedLabels(filter.id, alternate);
					});
				} else {
					tempLists[filter.id + '_alternate'] = getSelectedLabels(filter.id);
				}
			}
		}

		function reloadFactoryFilters(usingReduxStore, notDefaultAll, updateReportSettings) {
			updateHierarchicalFilters(usingReduxStore);
			var tempLists = {};
			self.updatingFilters = true;
			var i, filt;
			for (i = 0; i < self.masterFilterList.length; i++) {
				if (self.masterFilterList[i].url) {
					filt = self.masterFilterList[i];
					if (filt.updateOnFactory) {
						storeLastFilterSelection(tempLists, filt, notDefaultAll);
						currentAsync += 1;
						_getFilterData(filt.id, true);
					}
				} else if (self.masterFilterList[i].loadObjectList) {
					filt = self.masterFilterList[i];
					if (filt.updateOnFactory) {
						storeLastFilterSelection(tempLists, filt, notDefaultAll);
						_getFilterData(filt.id, true);
					}
				}
			}
			for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
				if (self.masterSingleSelectFilterList[i].url) {
					filt = self.masterSingleSelectFilterList[i];
					if (filt.updateOnFactory) {
						storeLastFilterSelection(tempLists, filt, notDefaultAll);
						currentAsync += 1;
						_getFilterData(filt.id, true);
					}
				} else if (self.masterSingleSelectFilterList[i].loadObjectList) {
					filt = self.masterSingleSelectFilterList[i];
					if (filt.updateOnFactory) {
						storeLastFilterSelection(tempLists, filt, notDefaultAll);
						_getFilterData(filt.id, true);
					}
				}
			}
			for (i = 0; i < self.masterStringFilterList.length; i++) {
				filt = self.masterStringFilterList[i];
				if (filt.url && filt.updateOnFactory) {
					_getFilterData(filt.id, true);
				}
			}
			_reapplyPreviousSelections(tempLists, usingReduxStore, updateReportSettings);
		}

		function getComparison(listOfData, compareWith, isCaseSensitive) {
			var valuesList = listOfData;
			valuesList = _.map(valuesList, function (data) {
				return '' + data;
			});
			var compareValue = '' + compareWith;

			if (!isCaseSensitive) {
				valuesList = _.map(valuesList, function (data) {
					return _.toLower(data);
				});
				compareValue = _.toLower(compareValue);
			}

			return valuesList.indexOf(compareValue) > -1;
		}

		function compareKeyAndAlternateKey(filter, compareWith, previousSelectedIds, previousSelectedAlternateIds, tempLists) {
			if (_.isArray(filter.alternateComparisonKey)) {
				var matchFound = getComparison(previousSelectedIds, compareWith[filter.comparisonKey].toString(),
					filter.isCaseSensitive);
				// iterate all the alternate keys for a filter and check if the value exists
				if (!matchFound && tempLists) {
					for (var i = 0; i < filter.alternateComparisonKey.length; i++) {
						var alternateDataList = tempLists[filter.id + '_' + filter.alternateComparisonKey[i] + '_alternate'];
						if (alternateDataList) {
							matchFound = getComparison(alternateDataList, compareWith[filter.alternateComparisonKey[i]].toString(), filter.isCaseSensitive);
							 if (matchFound) {
								break;
							 }
						}
					}
				}
				return matchFound;
			} else {
				if (filter.alternateComparisonKey && previousSelectedAlternateIds) {
					return getComparison(previousSelectedIds, compareWith[filter.comparisonKey].toString(),
						filter.isCaseSensitive) || getComparison(previousSelectedAlternateIds,
						compareWith[filter.alternateComparisonKey].toString(), filter.isCaseSensitive);
				}
			}
			return getComparison(previousSelectedIds, compareWith[filter.comparisonKey].toString(), filter.isCaseSensitive);
		}

		function _reapplyPreviousSelections(tempLists, usingReduxStore, updateReportSettings) {
			if (currentAsync === 0 && firstFilterLoad) {
				for (var key in tempLists) {
					if (tempLists.hasOwnProperty(key) && !key.endsWith('_alternate')) {
						var filt = getFilterById(key);
						var selected = tempLists[key];
						var alternateSelected = tempLists[key + '_alternate'];
						var selectAll = false;
						if (selected && selected.length > 0 && selected[0] === self.leanDnaAllSelected) {
							selectAll = true;
						}
						for (var i = 0; i < filt.objectList.length; i++) {
							var obj = filt.objectList[i];
							if (selectAll) {
								obj.selected = true;
							} else if (compareKeyAndAlternateKey(filt, obj, selected, alternateSelected, tempLists)) {
								obj.selected = true;
							} else if (filt.comparisonKey !== filt.label){
								selected = tempLists[key].toString().split(',');
								var valueString = obj[filt.comparisonKey].toString();
								var valueArr = valueString.split(',');
								for (var j = 0; j < valueArr.length; j++) {
									if (getComparison(selected, valueArr[j].toString(), filt.isCaseSensitive)) {
										obj.selected = true;
									}
								}
							}
						}
						if (usingReduxStore) {
							var usedToHaveSelection = filt.selectedList && filt.selectedList.length > 0 && filt.selectedList[0] !== self.leanDnaAllSelected;
							var noneSelectedNow = !filt.objectList.some(function(e) { return e.selected; });
							if (usedToHaveSelection && noneSelectedNow) {
								// If none are actually selected after applying selected list, default to all
								for (var i = 0; i < filt.objectList.length; i++) {
									filt.objectList[i].selected = true;
								}
							}

							// Only update filters that already exists in the store.
							var filterSettingsList = storeService.getState().reportSettings.filters;
							if (_.find(filterSettingsList, {id: filt.id})) {
								storeService.updateFilterSettings(filt, self.reportName, self.reportSettingsId, true);
							}
						}
					}
				}
				if (usingReduxStore) {
					self.updateActiveFiltersRedux();
					if (updateReportSettings) {
						checkedBackendValues = false;
						updateFiltersInRedux();
					}
				} else {
					self.updateActiveFilters();
				}
			} else {
				$timeout(function () {
					checkAndUpdateAsync();
					_reapplyPreviousSelections(tempLists, usingReduxStore, updateReportSettings);
				}, 10);
			}
		}

		function getFilterByDefinitionName(filterName) {
			return self.filterDefinitions[filterName];
		}

		function getFilterById(filterId) {
			if (filterId === 'myItemsOnly') {
				return  {
					'id': filterId,
					'value': self.myItemFilter.selected.toString(),
					'type': 'string'
				};
			}
			var i;
			for (i = 0; i < self.masterFilterList.length; i++) {
				if (self.masterFilterList[i].id === filterId) {
					return self.masterFilterList[i];
				}
			}
			for (i = 0; i < self.masterRangeFilterList.length; i++) {
				if (self.masterRangeFilterList[i].id === filterId) {
					return self.masterRangeFilterList[i];
				}
			}
			for (i = 0; i < self.masterStringFilterList.length; i++) {
				if (self.masterStringFilterList[i].id === filterId) {
					return self.masterStringFilterList[i];
				}
			}
			for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
				if (self.masterSingleSelectFilterList[i].id === filterId) {
					return self.masterSingleSelectFilterList[i];
				}
			}
		}

		function _loadListData(retryCount, donotCallUpdateFilters) {
			retryCount = retryCount || 0;
			if (currentAsync != 0 && retryCount < 3) {
				retryCount++;
				$timeout(function() {
					_loadListData(retryCount, donotCallUpdateFilters);
				}, 10);
			}
			if (currentAsync != 0) {
				self.cancel.resolve('Cancelled Filters Requests');
				self.cancel = $q.defer();
				currentAsync = 0;
			}
			var i;
			for (i = 0; i < self.masterFilterList.length; i++) {
				if (self.masterFilterList[i].url) {
					currentAsync += 1;
					_getFilterData(self.masterFilterList[i].id);
				} else if (self.masterFilterList[i].loadObjectList) {
					_getFilterData(self.masterFilterList[i].id);
				}
			}
			for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
				if (self.masterSingleSelectFilterList[i].url) {
					currentAsync += 1;
					_getFilterData(self.masterSingleSelectFilterList[i].id);
				} else if (self.masterSingleSelectFilterList[i].loadObjectList) {
					_getFilterData(self.masterSingleSelectFilterList[i].id);
				}
			}
			for (i = 0; i < self.masterStringFilterList.length; i++) {
				if (self.masterStringFilterList[i].url) {
					currentAsync += 1;
					_getFilterData(self.masterStringFilterList[i].id);
				}
			}
			if (!donotCallUpdateFilters) {
				self.updateActiveFilters();
			}

		}

		function getList(filterId) {
			return getFilterById(filterId).objectList;
		}

		function getComparator(filterId) {
			return getFilterById(filterId).comparator;
		}

		function getValueOne(filterId) {
			return getFilterById(filterId).valueOne;
		}

		function getValueTwo(filterId) {
			return getFilterById(filterId).valueTwo;
		}

		function getValue(filterId) {
			return getFilterById(filterId).value;
		}

		function setComparator(filterId, comparator) {
			getFilterById(filterId).comparator = comparator;
		}

		function setValueOne(filterId, valueOne) {
			getFilterById(filterId).valueOne = valueOne;
		}

		function setValueTwo(filterId, valueTwo) {
			getFilterById(filterId).valueTwo = valueTwo;
		}

		function setValue(filterId, value) {
			getFilterById(filterId).value = value;
		}

		function getUrl(filterId) {
			return getFilterById(filterId).url;
		}

		function getComparisonKey(filterId) {
			return getFilterById(filterId).comparisonKey;
		}

		function getAuthorizationLevel(filterId) {
			return getFilterById(filterId).authorizationLevel;
		}

		function getAlternateKey(filterId) {
			return getFilterById(filterId).alternateKey;
		}

		function getLabel(filterId) {
			return getFilterById(filterId).label;
		}

		function getDisplayName(filterId) {
			return getFilterById(filterId).displayName;
		}

		function setSearchBoxDataValue(value) {
			self.searchBoxData = value;
		}

		function getSearchBoxDataValue() {
			return self.searchBoxData;
		}

		function isLoading() {
			return currentAsync > 0 || self.updatingFilters;
		}

		function clearFiltersLoaded() {
			firstFilterLoad = false;
		}

		function mouseOverDataSync() {
			timeoutForPopoverLeave && $timeout.cancel(timeoutForPopoverLeave);
			timeoutForPopoverOpen = $timeout(function () {
				self.popoverForDataSyncOpened = true;
				keepPopoverOpenedWhenHovering();
			});
		}

		function mouseLeaveDataSync() { 
			timeoutForPopoverOpen && $timeout.cancel(timeoutForPopoverOpen);
			timeoutForPopoverLeave = $timeout(function () {
				self.popoverForDataSyncOpened = false;
				turnOffEvents();
			}, 250);
		}

		function handlePopoverClick(evt) {
			event.stopPropagation();
			if (evt.target.className &&
				(evt.target.className.indexOf('tooltip-close') >= 0
					|| evt.target.className.indexOf('fa-times') >= 0)) {
				mouseLeaveDataSync();
			}
		}

		function turnOffEvents() {
			$timeout(function () {
				var el = jQuery('.popover.white-tooltip').first();
				el.off('mouseenter mouseleave');
				el.off('click');
			});
		}

		function keepPopoverOpenedWhenHovering() {
			$timeout(function () {
				var el = jQuery('.popover.white-tooltip').first();
				el.off('mouseenter mouseleave');
				el.off('click');
				el.on('mouseenter', mouseOverDataSync);
				el.on('mouseleave', mouseLeaveDataSync);
				el.on('click', handlePopoverClick);
			});
		}

		function getPopoverForDataSyncIssue(objectList, selectedList) {
			var countWithIssues = objectList.filter(function (site) {
				return site.selected && site.dataSyncIssue;
			}).length;
			var selectedLength = selectedList.length 
				&& selectedList.length === 1
				&& (selectedList[0] === 'LDNA_A_S' || selectedList[0] === 'All')
				? objectList.length : selectedList.length;
			if (countWithIssues > 0) {
				return getDataSyncIssueTooltip(selectedLength, countWithIssues);
			} 
			return '';
		}

		function getMyItemDisableFilterTooltip() {
			return '<div class="myTooltip filter-tooltip">'
				+ '<div class="tooltipHeader">' + $translate.instant('Your "Only My Items" filter is turned on.') + '</div>'
				+ '<div class="tooltipHeader">' + $translate.instant('You must turn it off to apply the Buyer filter.') + '</div>'
				+ '</div>';
		}

		function getDataSyncIssueTooltip(total, countWithIssue) {
			var text = '';
			var endingText = 'synced with the ERP in 24 hours.  Data may be inaccurate.';
			if (total === countWithIssue && total === 1) {
				text = $translate.instant('This site hasn\'t ' + endingText);
			} else if (countWithIssue === 1) {
				text = $translate.instant('One of your selected sites hasn\'t ' + endingText);
			} else {
				text = $translate.instant('{count} of your selected sites haven\'t ' + endingText).replace('{count}', countWithIssue);
			}
			return '<div class="myTooltip filter-tooltip data-sync-tooltip">'
				+ '<div class="tooltip-body">' + text + '</div>'
				+ '<a class="tooltip-link" target="_blank" href="/application/f/home.html#/setup/data-pipeline?drilldown=1">'
				+ $translate.instant('View Data Sync Status') + '</a>'
				+ '<div class="tooltip-close"><i class="fa fa-times"></i></div>'
				+ '</div>';
		}

		function getDisplayForRange(filterId, dateFormat) {
			var result = '';
			var type = self.getTypeOfFilter(filterId);
			result += $translate.instant(self.getComparator(filterId).name) + ' ';
			var val1 = self.getValueOne(filterId);
			result += (type === 'date' ? $filter('date')(val1, dateFormat ? dateFormat: 'shortDate') : val1);
			var val2 = self.getValueTwo(filterId);
			if ((val2 || val2 === 0) && (self.getComparator(filterId).name === 'Between' || self.getComparator(filterId).name === 'Not Between')) {
				result += ' ' + $translate.instant('and') + ' ' + (type === 'date' ? $filter('date')(val2, dateFormat ? dateFormat: 'shortDate') : val2);
			}
			return result;
		}

		function getRangeDisplayFromFilter(filter, dateFormat) {
			var comparator = filter.comparator.name;
			var valueOne = filter.valueOne;
			var valueTwo = filter.valueTwo;
			if (filter.type === 'date') {
				valueOne = $filter('date')(valueOne, dateFormat ? dateFormat: 'shortDate');
				valueTwo = $filter('date')(valueTwo, dateFormat ? dateFormat: 'shortDate');
			}

			var result = $translate.instant(comparator) + ' ' + valueOne;
			if ((comparator === 'Between' || comparator === 'Not Between') && (valueTwo || valueTwo === 0)) {
				result += ' ' + $translate.instant('and') + ' ' + valueTwo;
			}

			return result;
		}

		function getDisplayForString(filterId) {
			var filter = getFilterById(filterId);
			if (filter.getDisplayRaw) {
				return filter.getDisplayRaw(self.getValue(filterId), filter.objectList);
			}
			var result = '';
			if (filter.getDisplayValue) {
				result = filter.getDisplayValue(self.getValue(filterId), filter.objectList);
			} else {
				result = self.getValue(filterId);
			}
			return $translate.instant('Contains: {{filterStrSearch}}', { filterStrSearch: result});
		}

		function selectAllInActiveFilters() {
			var list;
			for (var i = 0; i < self.activeFilters.length; i++) {
				list = self.getList(self.activeFilters[i].id);
				for (var j = 0; j < list.length; j++) {
					list[j].selected = true;
				}
			}
			self.updateActiveFilters();
		}

		function mergeSelectFilterWithSettings(filter, filterSettings) {
			var i, j;
			var objectList = filter.objectList;
			var allSelected = filterSettings.values && filterSettings.values[0] === 'LDNA_A_S' ? true : false;

			// Set all object values to false (or true is LDNA_A_S selected)
			var defaultSelected = allSelected || filterSettings.unselectedValues ? true : false;
			for(i = 0; i < objectList.length; i++) {
				objectList[i].selected = defaultSelected;
			}

			// Switch selected for objects in values or unselectedValues
			var assignedValues = filterSettings.values ? filterSettings.values : filterSettings.unselectedValues;
			for(i = 0; i < assignedValues.length; i++) {
				var value = ('' + assignedValues[i]).toLowerCase();
				for(j = 0; j < objectList.length; j++) {
					if(('' + objectList[j][filter.comparisonKey]).toLowerCase() === value) {
						objectList[j].selected = !defaultSelected;
					}
				}
			}

			// Get selected values for display
			var selectedList = [];
			for (i = 0; i < objectList.length; i++) {
				if (objectList[i].selected) {
					var val = objectList[i][filter.label];
					if (filter.undefinedMap) {
						val = JSON.parse(filter.undefinedMap)[val] || val;
					}
					selectedList.push(val);
				}
			}
			var isSelectionDisabled = self.myItemFilter.enabled && self.myItemFilter.selected && filter.checkMyItems;
			var tooltip = filter.tooltip;
			var popover = filter.popover;

			if (isSelectionDisabled) {
				tooltip = getMyItemDisableFilterTooltip();
			}

			if (filter.id === 'factory') {
				popover = getPopoverForDataSyncIssue(objectList, selectedList);	
			}

			var mergedFilter = {
				id: filter.id,
				name: filter.displayName,
				list: objectList,
				label: filter.label,
				display: allSelected || selectedList.length === objectList.length ? 'All' : selectedList.toString(),
				type: filter.type,
				undefinedMap: filter.undefinedMap,
				removable: filter.removable,
				dynamicWidth: filter.dynamicWidth,
				tooltip: tooltip,
				popover: popover,
				disabledSelection: isSelectionDisabled,
				detail: filter.detail,
				groupKey: self.getGroupKey(filter.id),
				groupLabels: self.getGroupLabels(filter.id)
			};
			return mergedFilter;
		}

		function mergeStringFilterWithSettings(filter, filterSettings) {
			var activeFilter = {
				id: filter.id,
				name: filter.displayName,
				value: filterSettings.value,
				display: getDisplayForString(filter.id),
				type: filter.type,
				removable: filter.removable,
				isCustom: filter.isCustom
			};

			if (filter.isCustom && filter.type === 'demandSimulation') {
				activeFilter.list = filter.objectList;
			}
			return activeFilter;
		}

		function mergeRangeFilterWithSettings(filter, filterSettings) {
			var activeFilter = {
				id: filter.id,
				name: filter.displayName,
				comparator: _.find(self.comparators, ['name', filterSettings.comparator]),
				valueOne: filterSettings.valueOne,
				valueTwo: filterSettings.valueTwo,
				value: filterSettings.value,
				type: filter.type,
				isCustom: filter.isCustom,
				removable: filter.removable,
				showNotBtw: filter.showNotBtw
			};

			if (filter.isCustom) {
				activeFilter.list = filter.objectList;
				activeFilter.label = filter.label;
				if (filterSettings.value === 'custom') {
					if (filter.type === 'date') {
						activeFilter.comparator = _.find(self.comparators, ['name', 'Between']);
						filter.comparator = _.clone(activeFilter.comparator);
					}
					if (filterSettings.valueOne && filterSettings.valueTwo || filter.type === 'numerical') {
						activeFilter.display = getRangeDisplayFromFilter(filter, 'MMM yyyy');
					} else {
						activeFilter.value = 'all';
						activeFilter.display = 'All';
					}
				} else {
					activeFilter.display = _.find(filter.objectList, [filter.comparisonKey, filterSettings.value])[filter.label];
				}
			} else {
				activeFilter.display = getRangeDisplayFromFilter(activeFilter);
			}

			return activeFilter;
		}

		function enableFilters() {
			for(i = 0; i < self.masterFilterList.length; i++) {
				filter = self.masterFilterList[i];
				if (filter.objectList && filter.objectList.length) {
					filter.disabled = false;
				} else {
					filter.disabled = true;
				}
			}
			for(i = 0; i < self.masterSingleSelectFilterList.length; i++) {
				filter = self.masterSingleSelectFilterList[i];
				if (filter.objectList && filter.objectList.length) {
					filter.disabled = false;
				} else {
					filter.disabled = true;
				}
			}
			for(i = 0; i < self.masterRangeFilterList.length; i++) {
				self.masterRangeFilterList[i].disabled = false;
			}
			for(i = 0; i < self.masterStringFilterList.length; i++) {
				self.masterStringFilterList[i].disabled = false;
			}
		}

		function updateFiltersDependsOnMyItemFilter() {
			// Disable active filters that are effected by my items only
			var activeFilterIds = [];
			angular.forEach(self.activeFilters, function(af) {
				var filter = self.getFilterById(af.id);
				if (filter.checkMyItems) {
					af.disabledSelection = self.myItemFilter.selected;
					if (af.disabledSelection) {
						af.tooltip = getMyItemDisableFilterTooltip();
					} else {
						af.tooltip = filter.tooltip;
					}
				}
				activeFilterIds.push(af.id);
			});
			for (var i = 0; i < self.masterFilterList.length; i++) {
				var filter = self.getFilterById(self.masterFilterList[i].id);
				if (filter.checkMyItems && !_.includes(activeFilterIds, filter.id)) {
					self.masterFilterList[i].disabled = self.myItemFilter.selected;
					if (!(filter.objectList && filter.objectList.length)) {
						self.masterFilterList[i].disabled = false;
					}

					if (self.masterFilterList[i].disabled) {
						self.masterFilterList[i].tooltip = getMyItemDisableFilterTooltip();
					} else {
						self.masterFilterList[i].tooltip = '';
					}
				}
			}
		}

		function updateActiveFiltersRedux() {
			if (currentAsync === 0 && firstFilterLoad && (!self.useFactoryFilter || self.factoriesSelected)) {
				self.activeFilters.length = 0;
				enableFilters();

				var filterSettingsList = storeService.getState().reportSettings.filters;
				for(var i = 0; i < self.masterFilterList.length; i++) {
					var filter = self.masterFilterList[i];
					var filterSettings = _.find(filterSettingsList, {id: filter.id});
					var isSelectionDisabled = self.myItemFilter.enabled && self.myItemFilter.selected && filter.checkMyItems;
					if (filterSettings && hasValidValues(filter, filterSettings)) {
						filter.disabled = true;
						self.activeFilters.push(mergeSelectFilterWithSettings(filter, filterSettings));
					} else if (isSelectionDisabled) {
						filter.disabled = true;
					}

					if (filter.checkMyItems) {
						if (isSelectionDisabled) {
							self.masterFilterList[i].tooltip = getMyItemDisableFilterTooltip();
						} else {
							self.masterFilterList[i].tooltip = '';
						}
					}
				}
				for(var i = 0; i < self.masterRangeFilterList.length; i++) {
					var filter = self.masterRangeFilterList[i];
					var filterSettings = _.find(filterSettingsList, {id: filter.id});
					if (filterSettings && hasValidValues(filter, filterSettings)) {
						filter.disabled = true;
						self.activeFilters.push(mergeRangeFilterWithSettings(filter, filterSettings));
					}
				}
				for(var i = 0; i < self.masterStringFilterList.length; i++) {
					var filter = self.masterStringFilterList[i];
					var filterSettings = _.find(filterSettingsList, {id: filter.id});
					if (filterSettings && hasValidValues(filter, filterSettings)) {
						filter.disabled = true;
						self.activeFilters.push(mergeStringFilterWithSettings(filter, filterSettings));
					}
				}
				for(var i = 0; i < self.masterSingleSelectFilterList.length; i++) {
					var filter = self.masterSingleSelectFilterList[i];
					var filterSettings = _.find(filterSettingsList, {id: filter.id});
					if (filterSettings && hasValidValues(filter, filterSettings)) {
						filter.disabled = true;
						if (filter.objectList && filter.objectList.length) {
							self.activeFilters.push(mergeSelectFilterWithSettings(filter, filterSettings));
						}
					}
				}
				$timeout(function () {
					initFilterContainer();
				}, 100);

				self.updatingFilters = false;
			} else {
				$timeout(function () {
					checkAndUpdateAsync();
					self.updateActiveFiltersRedux();
				}, 10);
			}
		}

		function hasValidValues(filter, settings) {
			if (filter.type === 'multiselect') {
				return (settings.values && settings.values.length)
					|| (settings.unselectedValues && settings.unselectedValues.length);

			} else if (filter.type === 'numerical') {
				return ((settings.valueOne || settings.valueOne === 0)
					&& settings.comparator) || (filter.isCustom && settings.value);

			} else if (filter.type === 'date') {
				return (settings.valueOne && settings.comparator)
					|| (filter.isCustom && settings.value);
			
			} else if (filter.type === 'string' || filter.type === 'demandSimulation') {
				return settings.value;

			} else if (filter.type === 'singleSelect') {
				return settings.values && settings.values.length === 1;

			} else {
				return false;
			}
		}

		function updateFiltersInRedux(isDrilldown) {
			var shouldUpdate = (factoryFilterChanged || self.filtersHaveBeenUpdatedFromConfig) && !checkedBackendValues;
			if (!shouldUpdate) {
				return;
			}

			var activeFilters = self.activeFilters.map(function (filter) {
				return getFilterById(filter.id);
			});

			var readOnly = storeService.getState().reportSettings.readOnly === true;
			var userModified = storeService.getState().reportSettings.userModified;
			var storeFilterIds = storeService.getState().reportSettings.filters.map(function (filter) {
				return filter.id;
			});
			var activeFilterIds = activeFilters.map(function (filter) {
				return filter.id;
			});
			var oldFilters = _.difference(storeFilterIds, activeFilterIds);
			for (var i = 0; i < activeFilters.length; i++) {
				var doNotSave = i < activeFilters.length - 1 || readOnly || self.isFirstLoadDrilldown;
				storeService.updateFilterSettings(activeFilters[i], self.reportName, self.reportSettingsId, doNotSave, userModified);
			}

			for (var i = 0; i < oldFilters.length; i++) {
				if (oldFilters[i] !== 'myItemOnly' && oldFilters[i] !== 'myItemsOnly') {
					var doNotSave = i < oldFilters.length - 1 || readOnly || isDrilldown;
					storeService.dispatch({
						type: storeService.actions.FILTERS_DELETE_ONE,
						payload: {
							id: oldFilters[i]
						},
						meta: {
							reportName: self.reportName,
							reportSettingsId: self.reportSettingsId,
							userModified: userModified,
							doNotSave: doNotSave
						}
					});
				}
			}

			factoryFilterChanged = false;
			checkedBackendValues = true;
			self.isFirstLoadDrilldown = false;
		}

		function updateActiveFilters(usingReduxStore, isDrilldown) {
			var i, filterId, selectedLabels, fi;
			if (currentAsync === 0 && firstFilterLoad && (!self.useFactoryFilter || self.factoriesSelected)) {
				self.activeFilters.length = 0;
				for (i = 0; i < self.masterFilterList.length; i++) {
					filterId = self.masterFilterList[i].id;
					selectedLabels = getSelectedLabels(filterId);
					fi = getFilterById(filterId);
					var isSelectionDisabled = self.myItemFilter.enabled && self.myItemFilter.selected &&
						self.masterFilterList[i].checkMyItems;
					if (!fi.removable && (!selectedLabels || selectedLabels.length === 0) &&
							fi.objectList && fi.objectList.length > 0) {
						_.forEach(fi.objectList, function(item) {
							item.selected = true;
						});
						selectedLabels = getSelectedLabels(filterId);
					}
					if (selectedLabels && selectedLabels.length > 0 && fi.objectList && fi.objectList.length > 0) {
						var tooltip = self.masterFilterList[i].tooltip;
						var popover = self.masterFilterList[i].popover;

						if (isSelectionDisabled) {
							tooltip = getMyItemDisableFilterTooltip();
						} else {
							if (self.masterFilterList[i].checkMyItems) {
								self.masterFilterList[i].tooltip = '';
							}
						}
						if (filterId === 'factory') {
							popover = getPopoverForDataSyncIssue(fi.objectList, selectedLabels);
							
						}
						self.activeFilters.push({
							'id': filterId,
							'name': self.getDisplayName(filterId),
							'list': self.getList(filterId),
							'label': self.getLabel(filterId),
							'display': selectedLabels.toString(),
							'type': self.getTypeOfFilter(filterId),
							'undefinedMap': fi.undefinedMap,
							'removable': self.masterFilterList[i].removable,
							'dynamicWidth': self.masterFilterList[i].dynamicWidth,
							'tooltip': tooltip,
							'popover': popover,
							'disabledSelection': isSelectionDisabled,
							'detail': self.masterFilterList[i].detail,
							'groupKey': self.getGroupKey(filterId),
							'groupLabels': self.getGroupLabels(filterId)
						});
						self.masterFilterList[i].disabled = true;
					} else if (fi.objectList && fi.objectList.length) {
						self.masterFilterList[i].disabled = false;
						if (isSelectionDisabled) {
							self.masterFilterList[i].disabled = true;
							self.masterFilterList[i].tooltip = getMyItemDisableFilterTooltip();
						}
					} else {
						self.masterFilterList[i].tooltip = true;
					}
				}
				for (i = 0; i < self.masterRangeFilterList.length; i++) {
					filterId = self.masterRangeFilterList[i].id;
					var comparator = self.masterRangeFilterList[i].comparator;
					var isCustomFilter = self.masterRangeFilterList[i].isCustom &&
						(self.masterRangeFilterList[i].type === 'date' || self.masterRangeFilterList[i].type === 'numerical');
					var valueOne = self.masterRangeFilterList[i].valueOne;
					var filterValue = self.getValue(filterId);
					if (filterId.startsWith('cus_')) {
						fi = getFilterById(filterId);
						var filterSettingsList = storeService.getState().reportSettings.filters;
						var filterSettings = _.find(filterSettingsList, {id: fi.id});
						if (filterSettings && hasValidValues(fi, filterSettings)) {
							fi.disabled = true;
							self.activeFilters.push(mergeRangeFilterWithSettings(fi, filterSettings));
							continue;
						}
					}
					if ((comparator && (valueOne || valueOne === 0) && !jQuery.isEmptyObject(comparator)) 
							|| (isCustomFilter && filterValue)) {
						var display;
						if (isCustomFilter) {
							if (filterValue === 'custom') {

								self.masterRangeFilterList[i].comparator = self.masterRangeFilterList[i].type === 'date' ?
									_.find(self.comparators, ['name', 'Between']): comparator;
								var val1 = self.getValueOne(filterId);
								var val2 = self.getValueTwo(filterId);

								if ((val1 && val2) || self.masterRangeFilterList[i].type === 'numerical') {
									display = self.getDisplayForRange(filterId, 'MMM yyyy');
								} else {
									self.setValue(filterId, 'all');
									display = 'All';
								}
							} else {
								var displayValue =  _.find(self.masterRangeFilterList[i].objectList,
									[self.masterRangeFilterList[i].comparisonKey, filterValue]);
								if (displayValue) {
									display = displayValue[self.masterRangeFilterList[i].label];
								} else {
									display = '';
								}
							}
						} else {
							display = self.getDisplayForRange(filterId);
						}

						if (display) {
							var activeFilterObj = {
								'id': filterId,
								'name': self.getDisplayName(filterId),
								'comparator': self.getComparator(filterId),
								'valueOne': self.getValueOne(filterId),
								'valueTwo': self.getValueTwo(filterId),
								'display': display,
								'type': self.getTypeOfFilter(filterId),
								'removable': self.masterRangeFilterList[i].removable,
								'value': self.getValue(filterId),
								'showNotBtw': self.masterRangeFilterList[i].showNotBtw
							};
							if (isCustomFilter) {
								activeFilterObj.list = self.getList(filterId);
								activeFilterObj.isCustom = true;
								activeFilterObj.label = self.masterRangeFilterList[i].label;
							} else {
								activeFilterObj.isCustom = false;
							}
							self.activeFilters.push(activeFilterObj);
							self.masterRangeFilterList[i].disabled = true;
						}
					} else {
						self.masterRangeFilterList[i].disabled = false;
					}
				}
				for (i = 0; i < self.masterStringFilterList.length; i++) {
					filterId = self.masterStringFilterList[i].id;
					var value = self.masterStringFilterList[i].value;
					if (value) {
						var activeFilterObj = {
							'id': filterId,
							'name': self.getDisplayName(filterId),
							'value': self.getValue(filterId),
							'display': self.getDisplayForString(filterId),
							'type': self.getTypeOfFilter(filterId),
							'removable': self.masterStringFilterList[i].removable,
							'isCustom': self.isCustomFilter(filterId)
						};
						if (self.getTypeOfFilter(filterId) === 'demandSimulation') {
							activeFilterObj.list = self.getList(filterId);
						}
						self.activeFilters.push(activeFilterObj);
						self.masterStringFilterList[i].disabled = true;
					} else {
						self.masterStringFilterList[i].disabled = false;
					}
				}
				for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
					filterId = self.masterSingleSelectFilterList[i].id;
					selectedLabels = getSelectedLabels(filterId);
					fi = getFilterById(filterId);
					if (filterId === 'factory') {
						popover = getPopoverForDataSyncIssue(fi.objectList, selectedLabels);
					} else {
						popover = '';
					}
					if (selectedLabels && selectedLabels.length > 0 && fi.objectList && fi.objectList.length > 0) {
						self.activeFilters.push({
							'id': filterId,
							'name': self.getDisplayName(filterId),
							'list': self.getList(filterId),
							'label': self.getLabel(filterId),
							'display': selectedLabels.toString(),
							'type': self.getTypeOfFilter(filterId),
							'removable': self.masterSingleSelectFilterList[i].removable,
							'popover': popover
						});
						self.masterSingleSelectFilterList[i].disabled = true;
					} else if (fi.objectList && fi.objectList.length) {
						self.masterSingleSelectFilterList[i].disabled = false;
					} else {
						self.masterSingleSelectFilterList[i].disabled = true;
					}
				}

				$timeout(function () {
					initFilterContainer();
				}, 100);

				if (usingReduxStore) {
					updateFiltersInRedux(isDrilldown);
				}
				
				self.updatingFilters = false;
				if (self.filtersHaveBeenUpdatedFromConfig) {
					$rootScope.$broadcast('filterLoadingFinished');
				}
			} else {
				$timeout(function () {
					checkAndUpdateAsync();
					self.updateActiveFilters(usingReduxStore);
				}, 10);
			}
		}

		function checkAndUpdateAsync() {
			if (currentAsync < 0) {
				if (lastAsync === currentAsync) {
					currentAsync = 0;
				} else {
					lastAsync = currentAsync;
				}
			}
		}

		function resizeFiltersContainer() {
			var isDashboardPage = jQuery('.dashboard-container').length > 0;
			var searchBoxWidth = (jQuery('.searchBlock').length > 0 ? jQuery('.searchBlock').width() : (isDashboardPage ? 100 : 0));
			var myItemFilter = (jQuery('.my-item-filter').length > 0 ? jQuery('.my-item-filter').width() : (isDashboardPage ? 100 : 0));
			var width = jQuery('.row').width() - searchBoxWidth;
			var width2 = jQuery('.filtersContainer .row').width() - searchBoxWidth - 40;
			var totalFilters = self.activeFilters.length;
			var minWidthOfFilters = totalFilters * 54 + jQuery('.filters.dropdown').width() + myItemFilter;
			var totalFilterWidth = 0;
			jQuery('.filtersContainer .currentFilters').each(function(index) {
				totalFilterWidth += parseInt(jQuery(this).width());
			});
			width2 = width2 - totalFilterWidth;
			if (width2 < minWidthOfFilters) {
				jQuery('.filtersContainer').css('height', 'auto');
				jQuery('.filtersContainer .row').css('height', 'auto');
				jQuery('.filterRowWidthAdjuster').css('width', width);
			} else {
				if (!(jQuery('.extraText') && jQuery('.extraText').length)) {
					jQuery('.filtersContainer .row').css('height', 44);
					jQuery('.filtersContainer').css('height', 44);
				} else {
					jQuery('.filtersContainer').css('height', 0);
				}

				jQuery('.filterRowWidthAdjuster').css('width', '100%');
			}
			jQuery('.filtersContainer.tableAttached').css('height', 56);
			jQuery('.filtersContainer.tableAttached .row').css('height', 52);
			width = width - jQuery('.filters.dropdown').width() - myItemFilter;
			var maxWidth = width / totalFilters - 16 > 400 ? 400 : Math.floor(width / totalFilters) - 16;
			jQuery('.filtersContainer .currentFilters').css('maxWidth', maxWidth);
			jQuery('.filtersContainer .currentFilters .filterEdit').css('maxWidth', maxWidth);
		}

		function initFilterContainer() {
			// If there are active filters than wait for them to get displayed, so that we can resize them
			var filterContainerActiveFilters = self.activeFilters.length ?
				jQuery('.filtersContainer .currentFilters').width() : 1;
			if (filterContainerActiveFilters) {
				resizeFiltersContainer();
			} else {
				$timeout(function () {
					initFilterContainer();
				}, 10);
			}
		}

		function getFiltersForPost() {
			// Wait til filters are done loading
			var filters = [];
			self.masterFilterList.forEach(function(filter) {
				var filterValue = undefined;
				var selected = getSelectedIds(filter.id);
				var unselected = getUnselectedIds(filter.id);
				var filterDef = getFilterById(filter.id);
				var useUnselected = filterDef.useNotSelected
					&& unselected.length > 0
					&& (unselected.length < selected.length || (selected.length === 0 && !firstFilterLoad));
				var values = useUnselected ? unselected : selected;
				if (filter.sendAllValues) {
					useUnselected = false;
					values = selected;
				}
				if (values && values.length && (filter.sendAllValues || (!filter.sendAllValues && !_checkForAllSelected(filter)))) {
					if (filter.noEscapeComma) {
						// noEscapeComma really means that commas in values are value separators
						values = _.flatten(_.invokeMap(values, String.prototype.split, ','));
					}
					filterValue = {
						key: filter.id,
						value: values,
						operator: filter.operator ? filter.operator : useUnselected ? 'notin' : 'in'
					};
				}

				if (filterDef.checkMyItems && self.myItemFilter.enabled && self.myItemFilter.selected) {
					filterValue = {
						key: filter.id,
						value: self.myItemFilter.value.split(','),
						operator: 'in'
					};
				}

				if (filterValue) {
					filters.push(filterValue);
				}
			});
			self.masterRangeFilterList.forEach(function(filter) {
				var comparator = self.getComparator(filter.id);
				var value = self.getValue(filter.id);
				var valueOne = self.getValueOne(filter.id);
				var valueTwo = self.getValueTwo(filter.id);
				var isCustomNumericFilter = filter.isCustom && filter.type === 'numerical';
				var isCustomDateFilter = filter.isCustom && filter.type === 'date';

				if (isCustomNumericFilter) {
					if (value == 'custom') {
						filter.objectList.forEach(function (filterValue) {
							if (filterValue.value !== 'custom') {
								filters.push({
									key: filter.id,
									operator: 'noteq',
									value: filterValue.value
								});
							}
						});
					} else if (value && value !== 'custom') {
						comparator = {abbr: 'eq'};
						valueOne = value;
					}
				}

				if (isCustomDateFilter && value && value !== 'custom') {
					filters.push({
						key: filter.id,
						operator: 'eq',
						value: value
					});
				} else if (!_.isEmpty(comparator) && (valueOne || valueOne === 0)) {
					if (filter.type === 'date') {
						valueOne = $filter('date')(valueOne, 'yyyy-MM-dd');
						valueTwo = $filter('date')(valueTwo, 'yyyy-MM-dd');
					}
					filters.push({
						key: filter.id,
						operator: comparator.abbr,
						value: comparator.abbr === 'btw' || comparator.abbr === 'notbtw'? [valueOne, valueTwo] : valueOne
					});
				} else if (value) {
					// Handle filters that use value instead of valueOne (like time period filters)
					filters.push({
						key: filter.id,
						operator: comparator && comparator.abbr ? comparator.abbr : 'eq',
						value: value
					});
				}
			});
			self.masterStringFilterList.forEach(function(filter) {
				var value = self.getValue(filter.id);
				if (value) {
					filters.push({
						key: filter.id,
						operator: 'like',
						value: value
					});
				}
			});
			self.masterSingleSelectFilterList.forEach(function(filter) {
				selected = getSelectedIds(filter.id);
				if (selected && selected.length) {
					filters.push({
						key: filter.id,
						operator: 'eq',
						value: selected
					});
				}
			});
			if (self.searchBoxData !== '') {
				var value = self.searchBoxData;
				var operator = 'contains';
				if (self.searchType === 'item') {
					if (value.indexOf('Starts with') === 0) {
						value = value.substring(13, value.length - 1);
						operator = 'startsWith';
					} else if (value.indexOf('Contains') === 0) {
						value = value.substring(10, value.length - 1);
						operator = 'contains';
					} else {
						operator = 'eq';
					}
				}

				filters.push({
					key: 'search',
					operator: operator,
					value: value,
					type: self.searchType
				});
			}
			return filters;
		}

		function getFilterConfigForStorage() {
			// Wait til filters are done loading
			var filterConfig = [];
			var i, j, filterId, config, selected;
			for (i = 0; i < self.masterFilterList.length; i++) {
				filterId = self.masterFilterList[i].id;
				selected = getSelectedIds(filterId);
				var unselected = getUnselectedIds(filterId);
				var filter = getFilterById(filterId);
				var useUnselected = false;
				var obList = [];
				if ((selected.length > unselected.length || (selected.length === 0 && !firstFilterLoad)) &&
						unselected.length > 0 && filter.useNotSelected) {
					useUnselected = true;
					for (j = 0; j < unselected.length; j++) {
						obList.push(unselected[j]);
					}
				} else {
					for (j = 0; j < selected.length; j++) {
						obList.push(selected[j]);
					}
				}
				for (j = 0; j < obList.length; j++) {
					obList[j] = encodeURIComponent(obList[j]);
				}
				if (obList && obList.length > 0) {
					config = {
						'id': filterId
					};
					if (useUnselected) {
						config.unselectedValues = obList;
					} else {
						config.values = obList;
					}
					filterConfig.push(config);
				}
			}
			for (i = 0; i < self.masterRangeFilterList.length; i++) {
				filterId = self.masterRangeFilterList[i].id;
				var comparator = self.getComparator(filterId);
				var valueOne = self.getValueOne(filterId);
				var valueTwo = self.getValueTwo(filterId);
				var value = self.getValue(filterId);
				var isCustomFilter = self.masterRangeFilterList[i].isCustom && (self.masterRangeFilterList[i].type === 'date' || self.masterRangeFilterList[i].type === 'numerical');
				if ((comparator && (valueOne || valueOne === 0) &&
					!jQuery.isEmptyObject(comparator)) || isCustomFilter) {
					config = {
						'id': filterId,
						'valueOne': valueOne
					};

					if (comparator && !jQuery.isEmptyObject(comparator)) {
						config.comparator = comparator.name;
						if (valueTwo && (comparator.name === 'Between' || comparator.name === 'Not Between')) {
							config.valueTwo = valueTwo;
						}
					}

					if (isCustomFilter && value) {
						config.value = value;
						filterConfig.push(config);
					} else if (!isCustomFilter) {
						filterConfig.push(config);
					}
				}
			}
			for (i = 0; i < self.masterStringFilterList.length; i++) {
				filterId = self.masterStringFilterList[i].id;
				var value = self.getValue(filterId);
				if (value) {
					config = {
						'id': filterId,
						'value': value
					};
					filterConfig.push(config);
				}
			}
			for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
				filterId = self.masterSingleSelectFilterList[i].id;
				selected = getSelectedIds(filterId);
				if (selected && selected.length > 0) {
					config = {
						'id': filterId,
						'values': selected
					};
					filterConfig.push(config);
				}
			}
			return filterConfig;
		}

		function updateFactoryFilterFromStoredConfig(backendConfig, doUpdate, usingReduxStore) {
			// Set the selected lists then call the rest of this stuff
			var filterList = ['factory', 'businessunit', 'division', 'entity'];
			self.reportSettingsId = backendConfig.reportSettingsId;
			self.reportName = backendConfig.reportName;
			var j;
			for (var i = 0; i < filterList.length; i++) {
				var filter = getFilterById(filterList[i]);
				if (!filter) {
					continue;
				}
				var index = findInArray(backendConfig.filters, 'id', filter.id);
				if (index !== -1) {
					var selectedList = backendConfig.filters[index].values || [];
					filter.selectedList = [];
					if (selectedList) {
						if (selectedList.length === 1 && selectedList[0] === 'LDNA_A_S') {
							filter.selectedList.push(decodeURIComponent(selectedList[0]));
						} else {
							var filterData = _.map(filter.masterObjectList, function (obj) {
								return obj[filterList[i] !== 'factory' ? filterList[i]: 'id'].toString();
							});
							for (j = 0; j < selectedList.length; j++) {
								if (_.includes(filterData, decodeURIComponent(selectedList[j]))) {
									filter.selectedList.push(decodeURIComponent(selectedList[j]));
								}
							}
						}
					}
					filter.unselectedList = backendConfig.filters[index].unselectedValues || [];
					if (filter.unselectedList) {
						for (j = 0; j < filter.unselectedList.length; j++) {
							filter.unselectedList[j] = decodeURIComponent(filter.unselectedList[j]);
						}
					}
				}
			}
			_updateFactoryFilterFromStoredConfigInner(backendConfig, doUpdate, usingReduxStore);
		}

		function _updateFactoryFilterFromStoredConfigInner(backendConfig, doUpdate, usingReduxStore) {
			self.factoriesSelected = false;
			var k;
			if (self.useFactoryFilter) {
				var filterList = ['factory', 'businessunit', 'division', 'entity'];
				for (var i = 0; i < filterList.length; i++) {
					var filterId = filterList[i];
					var factFilter = getFilterById(filterList[i]);
					if (!factFilter) {
						continue;
					}
					var items = factFilter.objectList;
					var index = findInArray(backendConfig.filters, 'id', filterId);
					var values = [];
					var unselectedValues = [];
					if (index !== -1) {
						values = backendConfig.filters[index].values || [];
						unselectedValues = backendConfig.filters[index].unselectedValues || [];
					}
					for (k = 0; k < values.length; k++) {
						values[k] = decodeURIComponent(values[k]);
					}
					for (k = 0; k < unselectedValues.length; k++) {
						unselectedValues[k] = decodeURIComponent(unselectedValues[k]);
					}
					var allSelected = false;
					if (values && values.length > 0 && values[0] === self.leanDnaAllSelected) {
						if (filterId === 'factory' && factFilter.type === 'singleSelect') {
							values = [getDefaultSiteForSiteFilter(factFilter.objectList)];
						} else {
							allSelected = true;
						}
					}
					var key = factFilter.comparisonKey;
					var lookAtUnselected = unselectedValues && unselectedValues.length && factFilter.useNotSelected;
					for (var j = 0; j < items.length; j++) {
						// FIXME: Special case for defaulting a filter option to unselected
						if (backendConfig.defaultConfig && items[j].selectedByDefault === false) {
							items[j].selected = false;
						} else if (!lookAtUnselected && (allSelected || jQuery.inArray(items[j][key].toString(), values) !== -1)) {
							items[j].selected = true;
						} else if (lookAtUnselected &&
								(allSelected || jQuery.inArray(items[j][key].toString(), unselectedValues) === -1)) {
							items[j].selected = true;
						} else {
							items[j].selected = false;
						}
					}
				}

				self.factoriesSelected = true;
				updateHierarchicalFilters(usingReduxStore);
				if (doUpdate && usingReduxStore) {
					self.updateActiveFiltersRedux();
				} else if (doUpdate) {
					self.updateActiveFilters();
				}
			}
		}

		function getDecodedValue(value) {
			var returnValue;
			try {
				returnValue = decodeURIComponent(value);
			} catch (err) {
				if (err instanceof URIError) {
					returnValue = value;
				} else {
					returnValue = null;
				}
			}
			return returnValue;
		}

		function updateFiltersFromStoredConfig(backendConfig, usingReduxStore, isDrilldown) {
			var filter, filterId, index, beFil, i, j;
			for (i = 0; i < self.masterRangeFilterList.length; i++) {
				var type = self.masterRangeFilterList[i].type;
				filterId = self.masterRangeFilterList[i].id;
				index = findInArray(backendConfig.filters, 'id', filterId);
				beFil = undefined;
				if (index !== -1) {
					beFil = backendConfig.filters[index];
				}
				self.setComparator(filterId, undefined);
				self.setValueOne(filterId, undefined);
				self.setValueTwo(filterId, undefined);
				if (beFil) {
					if (beFil.comparator) {
						self.setComparator(filterId, _getComparatorFromName(beFil.comparator));
					}
					if (beFil.valueOne === null) {
						beFil.valueOne = undefined;
					}
					if (beFil.valueTwo === null) {
						beFil.valueTwo = undefined;
					}
					if (type === 'numerical') {
						beFil.valueOne = (beFil.valueOne || beFil.valueOne === 0) ? parseFloat(beFil.valueOne) : undefined;
						beFil.valueTwo = (beFil.valueTwo || beFil.valueTwo === 0) ? parseFloat(beFil.valueTwo) : undefined;
					} else {
						if (beFil.valueOne && !isNaN(beFil.valueOne)) {
							beFil.valueOne = parseInt(beFil.valueOne);
						}
						if (beFil.valueTwo && !isNaN(beFil.valueTwo)) {
							beFil.valueTwo = parseInt(beFil.valueTwo);
						}
					}
					if (self.masterRangeFilterList[i].isCustom && beFil.value) {
						self.setValue(filterId, beFil.value);
					}
					self.setValueOne(filterId, beFil.valueOne);
					self.setValueTwo(filterId, beFil.valueTwo);
				}
			}
			for (i = 0; i < self.masterStringFilterList.length; i++) {
				filterId = self.masterStringFilterList[i].id;
				index = findInArray(backendConfig.filters, 'id', filterId);
				beFil = undefined;
				if (index !== -1) {
					beFil = backendConfig.filters[index];
				}
				self.setValue(filterId, undefined);
				if (beFil) {
					self.setValue(filterId, beFil.value);
				}
			}
			for (i = 0; i < self.masterFilterList.length; i++) {
				filter = self.masterFilterList[i];
				index = findInArray(backendConfig.filters, 'id', filter.id);
				if (index !== -1) {
					filter.selectedList = backendConfig.filters[index].values || [];
					for (j = 0; j < filter.selectedList.length; j++) {
						var decodedValue = getDecodedValue(filter.selectedList[j]);
						if (decodedValue) {
							filter.selectedList[j] = decodedValue;
						}
					}
					filter.unselectedList = backendConfig.filters[index].unselectedValues || [];
					for (j = 0; j < filter.unselectedList.length; j++) {
						var decodedValue = getDecodedValue(filter.unselectedList[j]);
						if (decodedValue) {
							filter.unselectedList[j] = decodedValue;
						}
					}
					filter.authorizationLevel = backendConfig.filters[index].authorizationLevel;
				}
			}
			for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
				filter = self.masterSingleSelectFilterList[i];
				index = findInArray(backendConfig.filters, 'id', filter.id);
				if (index !== -1) {
					filter.selectedList = backendConfig.filters[index].values || [];
					for (j = 0; j < filter.selectedList.length; j++) {
						var decodedValue = getDecodedValue(filter.selectedList[j]);
						if (decodedValue) {
							filter.selectedList[j] = decodedValue;
						}
					}
				}
			}

			index = findInArray(backendConfig.filters, 'id', 'myItemsOnly');
			if (index !== -1) {
				self.myItemFilter.enabled = true;
				self.myItemFilter.selected = backendConfig.filters[index].value === 'true';
			}
			savedQueryParam = getQueryParamsObject();
			applySelectFiltersFromStoredConfig(backendConfig, usingReduxStore, isDrilldown);
		}

		function applySelectFiltersFromStoredConfig(backendConfig, usingReduxStore, isDrilldown) {
			var i, j, k, l, filterId, items, index, values, key, alternateKey, allSelected;
			if (currentAsync === 0 && firstFilterLoad) {

				// empty backendConfig.reportName means from dashboard
				var backendSettingsAreForThisReport = !backendConfig.reportName
					|| globalReportName === backendConfig.reportName
					|| globalReportName === backendConfig.reportSettingsId;
				if (!backendSettingsAreForThisReport) {
					return;
				}

				for (i = 0; i < self.masterFilterList.length; i++) {
					var filterDefinition = self.masterFilterList[i];
					filterId = filterDefinition.id;
					items = filterDefinition.objectList;
					if (!items) {
						continue; // TODO: Handle non list based filters
					}
					index = findInArray(backendConfig.filters, 'id', filterId);
					values = [];
					var unselectedValues = [];
					if (index !== -1) {
						values = _.cloneDeep(backendConfig.filters[index].values) || [];
						unselectedValues = _.cloneDeep(backendConfig.filters[index].unselectedValues) || [];
					}
					for (k = 0; k < values.length; k++) {
						values[k] = ('' + values[k]).replace(/@@##/g, ',');
						values[k] = values[k].replace(/@@\*\*/g, '/');
					}
					for (k = 0; k < unselectedValues.length; k++) {
						unselectedValues[k] = ('' + unselectedValues[k]).replace(/@@##/g, ',');
						unselectedValues[k] = unselectedValues[k].replace(/@@\*\*/g, '/');
					}
					allSelected = false;
					if (values && values.length > 0 && values[0] === self.leanDnaAllSelected) {
						allSelected = true;
					}
					key = filterDefinition.comparisonKey;
					alternateKey = filterDefinition.alternateKey;
					var isCaseSensitive = filterDefinition.isCaseSensitive;
					var lookAtUnselected = unselectedValues && unselectedValues.length && filterDefinition.useNotSelected;
					for (j = 0; j < items.length; j++) {
						// FIXME: Special case for defaulting a filter option to unselected
						if (backendConfig.defaultConfig && items[j].selectedByDefault === false &&
								// check that item isn't in the selected list before defaulting
								values.indexOf(items[j][key].toString()) === -1 &&
								(!alternateKey || values.indexOf(items[j][alternateKey].toString()) === -1)) {
							items[j].selected = allSelected || false;
						} else if (!lookAtUnselected && (allSelected || getComparison(values, items[j][key], isCaseSensitive))) {
							items[j].selected = true;
						} else if (!lookAtUnselected && alternateKey && getComparison(values, items[j][alternateKey], isCaseSensitive)) {
							items[j].selected = true;
						} else if (lookAtUnselected && getComparison(unselectedValues, items[j][key], isCaseSensitive)) {
							items[j].selected = false;
						} else if (lookAtUnselected && alternateKey && getComparison(unselectedValues, items[j][alternateKey], isCaseSensitive)) {
							items[j].selected = false;
						} else {
							items[j].selected = !!lookAtUnselected;
							if (filterDefinition.noEscapeComma) {
								var masterValues = items[j][key].toString().split(',');
								var storedValues;
								if (lookAtUnselected) {
									storedValues = unselectedValues.length ? unselectedValues.toString().split(',') : unselectedValues;
								} else {
									storedValues = values.length ? values.toString().split(',') : values;
								}
								for (k = 0; k < masterValues.length; k++) {
									for (l = 0; l < storedValues.length; l++) {
										var masterValue = isCaseSensitive ? masterValues[k] : masterValues[k].toLowerCase();
										var storedValue = isCaseSensitive ? storedValues[l] : storedValues[l].toLowerCase();
										if (masterValue === storedValue) {
											items[j].selected = !lookAtUnselected;
											break;
										}
									}
								}
							}
						}
					}
				}
				for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
					filterId = self.masterSingleSelectFilterList[i].id;
					items = self.masterSingleSelectFilterList[i].objectList;
					if (!items) {
						continue; // TODO: Handle non list based filters
					}
					index = findInArray(backendConfig.filters, 'id', filterId);
					values = [];
					if (index !== -1) {
						values = backendConfig.filters[index].values;
					}
					allSelected = false;
					if (values && values.length > 0 && values[0] === self.leanDnaAllSelected) {
						// Special Case to handle single select site filter
						if (filterId === 'factory') {
							values = [getDefaultSiteForSiteFilter(items)];
						} else { 
							allSelected = true;
						}
					}
					key = self.masterSingleSelectFilterList[i].comparisonKey;
					alternateKey = self.masterSingleSelectFilterList[i].alternateKey;
					for (j = 0; j < items.length; j++) {
						if (allSelected || getComparison(values, items[j][key].toString(), self.masterSingleSelectFilterList[i].isCaseSensitive)) {
							items[j].selected = true;
						} else if (alternateKey) {
							if (getComparison(values, items[j][alternateKey].toString(), self.masterSingleSelectFilterList[i].isCaseSensitive)) {
								items[j].selected = true;
							}
						} else {
							items[j].selected = false;
						}
					}
				}
				self.filtersHaveBeenUpdatedFromConfig = true;
				self.updateActiveFilters(usingReduxStore, isDrilldown);
			} else {
				$timeout(function () {
					checkAndUpdateAsync();
					applySelectFiltersFromStoredConfig(backendConfig, usingReduxStore, isDrilldown);
				}, 10);
			}
		}

		function deleteReportSettings(reportSettingsScope) {
			if (!self.reportSettingsName) {
				// reportSettingsName was not set, cannot delete report settings
				return;
			}
			var encodedReportSettingsName = encodeURIComponent(self.reportSettingsName.split('/').join('@@**'));

			var url = URLS.apiPrefix + globalConfig.factory.id + '/ReportSettings/' + encodedReportSettingsName;
			var extraParams = {};
			if (self.reportSettingsScope) {
				extraParams['type'] = self.reportSettingsScope;
			}
			if (reportSettingsScope) {
				extraParams['type'] = reportSettingsScope;
			}
			var viewType = storeService.getState().reportSettings.viewType;
			if (viewType) {
				extraParams['viewType'] = viewType;
			}
			url = addQueryParam(url, null, extraParams, false);
			return $http.delete(url)
				.then(deleteConfigComplete)
				.catch(deleteConfigFailed);

			function deleteConfigComplete(response) {
				// reload to grab default report settings
				window.location.reload();
				return response;
			}

			function deleteConfigFailed(error) {
				// fails if it cannot find any stored report settings to delete
				return error;
			}
		}

		function _getComparatorFromName(name) {
			var result = {};
			angular.forEach(self.comparators, function (comp) {
				if (comp.name === name) {
					result = comp;
				}
			});
			return result;
		}

		function escapeCommasForOrderPolicies(erpOrderPolicies, erpOrderPolicy) {
			erpOrderPolicies.push(erpOrderPolicy.erpOrderPolicy.replace(/,/g, '@@##'));
		}

		function getFactoryList(getObject) {
			var filterId = 'factory';
			var result = '';
			var resultObj = [];
			if (!firstFilterLoad) {
				var filter = getFilterById(filterId);
				if (filter) {
					var authFacts = _.keys(globalConfig.user.authFacts);
					var compareList = filter.selectedList;
					if (filter.selectedList && filter.selectedList.length && filter.selectedList[0] === 'LDNA_A_S') {
						compareList = [];
						if (filter.type !== 'singleSelect') {
							_.forEach(filter.objectList, function (site) {
								compareList.push(site.id.toString());
							});
						} else {
							compareList.push(getDefaultSiteForSiteFilter(filter.objectList));
						}
					}
					resultObj = _.intersection(authFacts, compareList);
					if (resultObj && resultObj.length) {
						result = resultObj.toString();
					}
				}
			} else {
				var filterList = self.filterDefinitions['Factory'].type === 'singleSelect' ?
					self.masterSingleSelectFilterList : self.masterFilterList;
				for (var i = 0; i < filterList.length; i++) {
					if (filterList[i].id === filterId) {
						//Has factory filter
						angular.forEach(filterList[i].objectList, function (item) {
							if (item.selected) {
								if (result && result.length) {
									result += ',';
								}
								result += item[filterList[i].comparisonKey];
								var tempObj = {};
								tempObj[filterList[i].comparisonKey] = item[filterList[i].comparisonKey];
								tempObj[filterList[i].label] = item[filterList[i].label];
								tempObj.alias = item.alias;
								resultObj.push(tempObj);
							}
						});
					}
				}
			}
			if (!result || result === '') {
				var currentFilter = getFilterById(filterId);
				if (typeof currentFilter !== 'undefined') {
					var resultSet = _getAllFactoryList(currentFilter);
					result = resultSet.result;
					resultObj = resultSet.resultObj;
				} else {
					var factoryProps = self.useAdminFactory ? storeService.getState().adminConfig.factory : globalConfig.factory;
					result = factoryProps.id;
					resultObj = { 'name': factoryProps.name, 'id': factoryProps.id };
				}
			}
			return getObject ? resultObj : result;
		}

		function _getAllFactoryList(factoryFilter) {
			var resultSet = {
				result: '',
				resultObj: []
			};
			hasFactoryHierarchy = _checkForSelectedInHierarchyFilters().length > 0;
			if (hasFactoryHierarchy) {
				angular.forEach(factoryFilter.objectList, function (item) {
					if (resultSet.result && resultSet.result.length) {
						resultSet.result += ',';
					}
					resultSet.result += item[factoryFilter.comparisonKey];
					var tempObj = {};
					tempObj[factoryFilter.comparisonKey] = item[factoryFilter.comparisonKey];
					tempObj[factoryFilter.label] = item[factoryFilter.label];
					tempObj.alias = item.alias;
					resultSet.resultObj.push(tempObj);
				});
			} else {
				var siteId = parseInt(getDefaultSiteForSiteFilter(factoryFilter.objectList));
				resultSet = {
					result: siteId,
					resultObj: { 'name': globalConfig.factory.name, 'id': siteId }
				};
			}
			return resultSet;
		}

		function _addSpendSummaryExtraParam(requestParamList, obList, filterName, colName) {
			if (obList.length > 1) {
				requestParamList.push({ 'key': 'columns', 'value': filterName });
				self.spendSummaryReportGroup = filterName;
			} else {
				requestParamList.push({ 'key': 'columns', 'value': colName });
				self.spendSummaryReportGroup = colName;
			}
		}

		function _getHierarchyQueryParam(hasQueryParam) {
			var qParam = '';
			var hierarchyFilters = _checkForSelectedInHierarchyFilters();
			hierarchyFilters.forEach(function(filter) {
				if (hasQueryParam) {
					qParam += '&';
				} else {
					qParam += '?';
					hasQueryParam = true;
				}
				var obList = getSelectedIds(filter);
				if (obList && obList.length) {
					qParam += filter + '=' + encodeURIComponent(obList.toString());
				}
			});

			return qParam;
		}

		function _checkForSelectedInHierarchyFilters() {
			var list = ['businessunit', 'division', 'entity'];
			return list.filter(function(f) { return getSelectedIds(f).length > 0; });
		}

		function getQueryParamFromPath() {
			return Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1]).entries());
		}

		function getQueryParam(leaveDecoded, excludeMultiSelect, multiSelectOnly, excludeSearch, isDrilldown) {
			var i, filter = [], filterId, value, config;
			var filterMaster;
			var qParamList = [];
			if (!excludeMultiSelect) {
				for (i = 0; i < self.masterFilterList.length; i++) {
					var obj = undefined;
					filterId = self.masterFilterList[i].id;
					var obList = [];
					var atLeastOneNotSelected = false;
					var selectedIds = getSelectedIds(filterId);
					var unselectedIds = getUnselectedIds(filterId);
					var useUnselected = false;
					if (filterId === 'factory' && typeof self.masterFilterList[i].includeInFilter === 'undefined') {
						continue;
					}
					if ((selectedIds.length > unselectedIds.length || (selectedIds.length === 0 && !firstFilterLoad)) &&
						unselectedIds.length > 0 && self.masterFilterList[i].useNotSelected) {
						useUnselected = true;
						obList = unselectedIds;
					} else {
						obList = selectedIds;
					}
					if (filterId.startsWith('cus_')) {
						if (obList.length > 0 && obList[0] !== self.leanDnaAllSelected) {
							for (var j = 0; j < obList.length; j++) {
								obList[j] = obList[j].replaceAll(/,/g, '@@##');
							}
							filter.push({
								type: 'list',
								value: obList.toString(),
								field: filterId,
								comparison: 'eq'
							});
						}
						continue;
					}
					filterMaster = self.masterFilterList[i];
					if ((!filterMaster.noEscapeComma && obList && obList.length && typeof obList[0] === 'string') || isDrilldown) {
						for (var j = 0; j < obList.length; j++) {
							obList[j] = _.replace(obList[j],/,/g, '@@##');
						}
					}
					atLeastOneNotSelected = filterMaster.sendAllValues || (!filterMaster.sendAllValues && !_checkForAllSelected(filterMaster));

					if (obList.length > 0 && obList[0] !== self.leanDnaAllSelected && (
						atLeastOneNotSelected || filterId === 'entity' || filterId === 'businessunit' ||
						filterId === 'division' || filterMaster.sendAllValues)) {
						value = leaveDecoded ? obList.toString() : encodeURIComponent(obList.toString());
						obj = { 'value': value };
						if (useUnselected) {
							obj.key = 'not' + filterId.charAt(0).toUpperCase() + filterId.slice(1);
						} else {
							obj.key = filterId;
						}
					}

					if (filterMaster.checkMyItems && self.myItemFilter.enabled && self.myItemFilter.selected && !isDrilldown) {
						var buyerCodes = self.myItemFilter.value.split(',');
						angular.forEach(buyerCodes, function (buyerCode) {
							return buyerCode.replace(/,/g, '@@##');
						});
						obj = {
							key: filterMaster.id,
							value: leaveDecoded ? buyerCodes : encodeURIComponent(buyerCodes)
						};
					}

					if (obj) {
						qParamList.push(obj);
					}
				}
			}

			if (multiSelectOnly) {
				return qParamList;
			}

			for (i = 0; i < self.masterRangeFilterList.length; i++) {
				filterId = self.masterRangeFilterList[i].id;
				var comparator = self.getComparator(filterId);
				var value = self.getValue(filterId);
				var valueOne = self.getValueOne(filterId);
				var valueTwo = self.getValueTwo(filterId);
				var type = self.getTypeOfFilter(filterId);
				var isCustomDateFilter = self.masterRangeFilterList[i].isCustom && self.masterRangeFilterList[i].type === 'date';
				var isCustomNumericFilter = self.masterRangeFilterList[i].isCustom && self.masterRangeFilterList[i].type === 'numerical';
				if (comparator && (valueOne || valueOne === 0) &&
					!jQuery.isEmptyObject(comparator) || ((isCustomDateFilter || isCustomNumericFilter) && value)) {
					if (type === 'date') {
						valueOne = $filter('date')(valueOne, 'yyyy-MM-dd');
						valueTwo = $filter('date')(valueTwo, 'yyyy-MM-dd');
					}

					if (self.isCustomFilter(filterId) && isCustomDateFilter) {
						self.masterRangeFilterList[i].setQueryParam(filterId, qParamList, value, valueOne, valueTwo, leaveDecoded, type);
						continue;
					}
					var comparisonKey = (value && value !== 'custom') ? 'eq' : comparator.abbr;
					if (comparisonKey === 'btw' || comparisonKey === 'notbtw') {
						config = {
							'type': type === 'numerical' ? 'numeric' : 'date',
							'comparison': valueTwo > valueOne ? 'lte' : 'gte',
							'value': valueTwo,
							'field': filterId
						};
						filter.push(config);
					}

					config = {
						'type': type === 'numerical' ? 'numeric' : 'date',
						'comparison': (comparisonKey === 'btw' || comparisonKey === 'notbtw'? (valueTwo > valueOne ? 'gte' : 'lte') : comparisonKey),
						'value': isCustomNumericFilter && value != 'custom' ? value: valueOne,
						'field': filterId
					};
					filter.push(config);
				}
			}
			for (i = 0; i < self.masterStringFilterList.length; i++) {
				filterId = self.masterStringFilterList[i].id;
				value = self.getValue(filterId);
				if (value) {
					config = {
						'type': 'string',
						'value': value,
						'field': filterId
					};
					filter.push(config);
				}
			}
			for (i = 0; i < self.masterSingleSelectFilterList.length; i++) {
				filterId = self.masterSingleSelectFilterList[i].id;
				var selected = getSelectedIds(filterId);
				if (selected.length > 0) {
					qParamList.push({ 'key': filterId, 'value': selected.toString() });
				}
			}
			if (filter && filter.length) {
				filter = leaveDecoded ? JSON.stringify(filter).replace(/\"/g, '\'') : encodeURIComponent(JSON.stringify(filter));
				qParamList.push({ 'key': 'filter', 'value': filter });
			}
			if (self.searchBoxData !== '' && !excludeSearch) {
				var keyValue = 'itemSearch';
				var valueValue = self.searchBoxData;
				if (self.searchType === 'item') {
					if (valueValue.indexOf('Starts with') === 0) {
						qParamList.push({
							key: 'searchType',
							value: 'PREFIX'
						});
						valueValue = valueValue.substring(13, valueValue.length - 1);
					} else if (valueValue.indexOf('Contains') === 0) {
						qParamList.push({
							key: 'searchType',
							value: 'CONTAINS'
						});
						valueValue = valueValue.substring(10, valueValue.length - 1);
					} else {
						qParamList.push({
							key: 'searchType',
							value: 'EXACT'
						});
					}
				}
				if (self.searchType === 'supplier') {
					keyValue = 'supplierSearch';
				} else if (self.searchType === 'user') {
					keyValue = 'userSearch';
				} else if (self.searchType === 'project') {
					keyValue = 'projectSearch';
				} else if (self.searchType === 'task') {
					keyValue = 'taskSearch';
				} else if (self.searchType === 'goal') {
					keyValue = 'goalSearch';
				} else if (self.searchType === 'lateDeliveryCategory') {
					keyValue = 'supplierLateDeliveryIssueSearch';
				} else if (self.searchType === 'email') {
					keyValue = 'emailSearch';
				}

				if (!leaveDecoded) {
					valueValue = encodeURIComponent(valueValue);
				}

				qParamList.push({
					'key': keyValue,
					'value': valueValue
				});
			}
			return qParamList;
		}

		function getDefaultFilters() {
			return self.defaultFilters;
		}

		function addFilterQueryParams(url, excludeMultiselect, excludeSearch) {
			var filterQueryParam = self.getQueryParam(false, excludeMultiselect, false, excludeSearch);
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1) {
				qParams = '?' + parts[1];
			}
			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			return parts[0] + qParams;
		}

		function _checkForAllSelected(filter) {
			if (!firstFilterLoad) {
				return filter.selectedList && filter.selectedList.length > 0 && filter.selectedList[0] === self.leanDnaAllSelected;
			} else {
				var obList = filter.objectList;
				var atLeastOneSelected = false;
				var atLeastOneUnselected = false;
				if (!obList || !obList.length) {
					return true;
				}
				for (var i = 0; i < obList.length; i++) {
					if (obList[i].selected) {
						atLeastOneSelected = true;
					} else {
						atLeastOneUnselected = true;
					}
					if (atLeastOneSelected && atLeastOneUnselected) {
						return false;
					}
				}
				return true;
			}
		}

		function getQueryParamsObject(leaveDecoded, isDrilldown) {
			var queryParamsObject = {};
			var filterQueryParam = self.getQueryParam(leaveDecoded, null, null, null, isDrilldown);
			for (var i = 0; i < filterQueryParam.length; i++) {
				queryParamsObject[filterQueryParam[i].key] =  filterQueryParam[i].value;
			}

			if (self.myItemFilter.enabled && self.myItemFilter.selected) {
				queryParamsObject['myItemOnly'] =  self.myItemFilter.value;
				if (!isDrilldown) {
					queryParamsObject['buyerCode'] =  self.myItemFilter.value;
				}
			}

			return queryParamsObject;
		}

		function getTimePeriodFilterQueryParam(filterKey, rawValue, isObjectFormat) {
			var timePeriodQueryParam = {};
			if (rawValue) {
				var decodedValue = decodeURIComponent(rawValue);
				if (_.startsWith(decodedValue, '{') && _.endsWith(decodedValue, '}')) {
					timePeriodQueryParam[filterKey] = 'custom';
					decodedValue = JSON.parse(_.replace(decodedValue, /'/g, '"'));
					if (decodedValue.startDate && decodedValue.endDate) {
						timePeriodQueryParam[filterKey + 'ValueOne'] = decodedValue.startDate;
						timePeriodQueryParam[filterKey + 'ValueTwo'] = decodedValue.endDate;
						timePeriodQueryParam[filterKey + 'ValueComparator'] = 'btw';
					}
				} else {
					timePeriodQueryParam[filterKey] = rawValue;
				}

				if (!isObjectFormat) {
					timePeriodQueryParam = jQuery.param(timePeriodQueryParam);
				}
			} else {
				timePeriodQueryParam = !isObjectFormat ? '' : {};
			}
			return timePeriodQueryParam;
		}

		function getGroupLabels(filterId) {
			if (filterId === 'projectSavingsCategoryId') {
				return {
					true: $translate.instant('Included in totals'),
					false: $translate.instant('Not included in totals')
				};
			}
			if (filterId === 'lateDeliveryDescription') {
				return {
					Late: $translate.instant('Late'),
					Early: $translate.instant('Early')
				};
			}
		}

		function getGroupKey(filterId) {
			if (filterId === 'projectSavingsCategoryId') {
				return 'includeInTotal';
			}
			if (filterId === 'lateDeliveryDescription') {
				return 'deliveryStatus';
			}
		}

		function getCustomFieldFilterNames() {
			return Object.keys(self.filterDefinitions)
				.filter(function (filterName) {
					return filterName.startsWith('cus_');
				});
		}

		function addCustomFieldsFilters() {
			Object.entries(self.filterDefinitions).forEach(function (filterObj) {
				var key = filterObj[0];
				var filter = filterObj[1];
				if (key.startsWith('cus_')) {
					addFilterObjectToFilterList(filter);
				}
			});
		}

		function addFilterObjectToFilterList(filter) {
			var index;
			switch (filter.type) {
			case 'string':
				index = self.masterStringFilterList.findIndex(function (existingFilter) {
					return existingFilter.id === filter.id;
				});
				if (index === -1) {
					self.masterStringFilterList.push(filter);
				}
				break;
			case 'multiselect':
				index = self.masterFilterList.findIndex(function (existingFilter) {
					return existingFilter.id === filter.id;
				});
				if (index === -1) {
					self.masterFilterList.push(filter);
				}
				break;
			case 'numerical':
			case 'date':
				index = self.masterRangeFilterList.findIndex(function (existingFilter) {
					return existingFilter.id === filter.id;
				});
				if (index === -1) {
					self.masterRangeFilterList.push(filter);
				}
				break;
			}
		}
	}
})();
